import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { EndpointType } from 'src/app/models/endpoint-type';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { UrlService } from 'src/app/services/util/url.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ClipboardService } from 'ngx-clipboard';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { InstanceDetailsAddRouteComponent } from './instance-details-add-route/instance-details-add-route.component';
import cloneDeep from 'lodash/cloneDeep';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { translate } from '@jsverse/transloco';
import { SweetAlertService } from 'src/app/services/util/sweet-alert.service';
import { Constants } from 'src/app/models/constants';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ChangeDetectorRef } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { InstanceDatePickerComponent } from './instance-date-picker/instance-date-picker.component';
import { DatePipe } from '@angular/common'
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { CustomTooltipComponent } from 'src/app/main/custom-tooltip/custom-tooltip.component';
import { PopupHostDirective } from 'src/app/directives/host.directive';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { AddSshKeyComponent } from './add-ssh-key/add-ssh-key.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, combineLatest, finalize, forkJoin, map, mergeMap, of } from 'rxjs';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { Solution } from 'src/app/models/service/solution';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { Blueprint, InstanceTabs } from 'src/app/models/blueprints/blueprint';
import { Instance } from 'src/app/models/instance/instance';
import { Configuration } from 'src/app/models/configurations/configuration';
import { DeploymentClass } from 'src/app/models/instance-class';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { ConfigurationApplicationStatus, ConfigurationPackageStatus,
  ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { Sort, SortDirection } from 'src/app/models/sort';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { isDate } from 'src/app/services/util/utils';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { NotificationsService } from 'src/app/services/api/notifications.service';
import { VerifypopupComponent } from '../verifypopup/verifypopup.component';
import { SkiptestPopupComponent } from '../skiptest-popup/skiptest-popup.component';
import { ConfigurationDetailsComponent } from '../configuration-details/configuration-details.component';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { DateTimeService } from 'src/app/services/util/date-time.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { InstanceEnvironment } from 'src/app/models/instance-environment';
import { TimeDurationPipe } from 'src/app/pipes/timeDuration.pipe';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InstallationSpecificationService} from 'src/app/services/util/installation-specification.service';
import { CobService } from 'src/app/services/api/cob.service';
import { DynamicFormComponent } from '../dynamic-form-cob/dynamic-form.component';
import cronstrue from 'cronstrue';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { TestTypes } from 'src/app/models/instance/test-types';
import { DbBackupFormComponent } from './db-backup-form/db-backup-form.component';
import { CobDetailsComponent } from './cob-details/cob-details.component';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';
import { DatabaseBackupComponent } from '../database-backup/database-backup.component';
import { DropdownFliterComponent } from '../dropdown-fliter/dropdown-fliter.component';
import { BackupService } from 'src/app/services/api/backup.service';
import { AddEncKeyComponent } from './add-enc-key/add-enc-key.component';
import moment from 'moment';
import { InventoryService } from 'src/app/services/api/inventory.service';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { CloudResourcesInventoryComponent } from '../instance-details/cloud-resources-inventory/cloud-resources-inventory.component';
import { KubernetesResource } from 'src/app/models/kubernetes-resource';
import { InventoryKubernetesComponent } from '../inventory-kubernetes/inventory-kubernetes.component';
import { DbBackupDetailsComponent } from './db-backup-details/db-backup-details.component';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
import { CapitalizeFirstPipe } from 'src/app/pipes/capitalize-first.pipe';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { ActivityDetailsComponent } from '../activity-details/activity-details.component';
import { AvailabilityStatus } from 'src/app/models/availability-status';
import { ActivityService } from 'src/app/services/api/activity.service';

type ComparatorFunc = (first: any, second: any) => number;

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.SANITY_TEST_NONPII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.SANITY_TEST_PII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.SANITY_TEST_LIVE,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.EF_TEST_NONPII,
    name: Feature.EF_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.COB_NONPII,
    name: Feature.COB,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.COB_PII,
    name: Feature.COB,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.COB_LIVE,
    name: Feature.COB,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_NONPII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_PII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_LIVE,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.DATABASE_ARCHIVE_LIVE,
    name: Feature.DATABASE_ARCHIVE,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.RVT_TEST_NONPII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.RVT_TEST_PII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  }
];

@Component({
    selector: 'app-instance-details',
    templateUrl: './instance-details.component.html',
    styleUrls: ['./instance-details.component.scss'],
    providers: [
        TimeDurationPipe,
        DurationPipe,
        CapitalizeFirstPipe
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})

export class InstanceDetailsComponent  implements OnInit {
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @Input() data: any;
  @Input() isLoading: any;
  @Input() solution: any;
  @Input() getBlueprints: any
  @Input() logLevel: any
  @Input() serviceVersions: any;
  @Input() solutionVersion: any;
  @Input() runHours: any;
  @Input() shutDownHours: any;
  @Input() timetakenChartLoaded = false;
  @Input() isResponseOk = false;
  @Input() isErrorResponse = false
  @Output() changeTask = new EventEmitter();
  @Output() updateInstnace = new EventEmitter();
  @ViewChild(PopupHostDirective) private popupHost: PopupHostDirective;
  private destroyRef = inject(DestroyRef);
  currentElement: any;
  private componentRef: ComponentRef<CustomTooltipComponent>;
  Constants = Constants;
  permissionsMap: { [key: string]: boolean };
  expandedElement: any;
  expandedPackageElement: any;
  DeployStatus = DeployStatus;
  configTypeEndpoints: any;
  accessTypeEndpoints: any;
  exploreTypeEndpoints: any;
  otherTypeEndpoints: any;
  isEndpointAvailable = false;
  copy = false;
  disableLogs = true;
  sftp: boolean;
  displayedColumns: string[] = ['expand', 'routeName', 'routeId', 'direction', 'encryption', 'status', 'menu'];
  logColumns: string[] = ['menu', 'action', 'startTime', 'finishTime', 'duration', 'success', 'failure', 'status','initiatedBy', 'jobId', 'arrow'];
  innerLogColumns: string[] = ['componentName', 'version', 'startTime', 'endTime', 'duration', 'status', 'arrow'];
  testResultColumns: string[] = ['testStartTime', 'testFinishTime', 'duration', 'initiatedBy', 'status', 'testResultsPath'];
  cobColumns: string[] = ['menu','id', 'date', 'timeTaken', 'completionMode', 'status', 'download', 'cobMenu'];
  innerCobColumns: string[] = ['stage', 'startTime', 'endTime', 'duration', 'status', 'message'];
  routeData: any;
  dataSource: any;
  dataSourceLog: any;
  dataSourceUpdateLog: any;
  dataSourceInnerLog: any;
  dataSourceUpdateInnerLog: any;
  dataSourceExternalPackages: any;
  paginationSize = 10;
  sanityPaginationSize = 10;
  EFPaginationSize = 10;
  cobPaginationSize = 10;
  showPagination = true;
  addingStatus: boolean;
  currentEnvironment: any;
  pageIndex = 0;
  sortInfo: any;
  filteredColumns: any;

  instanceDetailsKeys: any;
  direction: any;
  status: any;
  dropdownsList: any;
  clearData: boolean;
  viewResultsPaginator = false;
  sftpPaginator = false;
  logPaginator = false;
  sanityPaginator = false;
  EFPaginator = false;
  showSpinner: boolean;
  isFailed: boolean;
  isLogFailed: boolean;
  logData: any;
  deploymentLogData: any;
  updatedLogData: any;
  arrowClicked = false;
  addColor: any;
  deploymentLog : any;
  updatedLog: any;
  activeTab: number = 0;
  RouterSegments = RouterSegments;
  InstanceTabs = InstanceTabs;
  breadcrumbItems: BreadcrumbItem[];
  tenant: string;
  service: Solution;
  blueprint: Blueprint;
  instance: Instance;
  isOverview = true;
  isEndpoints = false;
  configurations: Configuration[];
  configPackage: string;
  buildNumber: string;
  releaseVersion: any;
  isAMR: boolean;
  isReleasePack = false;
  isRvtPack = false;
  routeExpandedElement: any;
  showActivityLoader = true;

  configurationStates: ConfigurationState[];
  configuration: Configuration[];
  pageConfigurationStates: ConfigurationState[];
  filteredConfigurationStates: ConfigurationState[];

  ConfigurationApplicationStatus = ConfigurationApplicationStatus;
  ConfigurationPackageStatus = ConfigurationPackageStatus;
  DataZone = DataZone;

  configurationsMap: KeyValueMap<string, Configuration>;
  searchTerm: string;

  SortDirection = SortDirection;
  sort: Sort;

  configStateVerify = false;
  allInstances: any;
  skipTest: boolean;
  loadDataSubscription: Subscription;
  instanceBlueprint: any;
  deployedDate = new Date();
  currentDate = new Date();
  availableConfigurations: Configuration[];
  isLoadingConfigurations = true;
  applyConfigInProgress = false;
  appliedConfigurationState: ConfigurationState;
  selectedTab = 0;
  isVerifying = false;
  AvailabilityStatus = AvailabilityStatus;
  filterOptions: any = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Success',
      value: ['success']
    },
    {
      label: 'Failed',
      value: ['test_failed', 'configure_failed', 'failed']
    }
  ];

  selectedFilter: any =  {
    label: 'All',
    value: ''
  };

  allConfigurationStates: ConfigurationState[] = [];
  istanceLoaded = false;
  releaseManager = false;
  DeploymentClass = DeploymentClass;
  configResultsLoaded = false;

  statusIcons = {
    deployed: 'done',
    failed: 'close',
    terminated: 'error_outline',
    inprogress: 'change_circle',
    operation_inprogress: 'change_circle',
  };

  loaderStatus = [
    DeployStatus.DEPLOYING,
    DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING,
    DeployStatus.UPDATING,
    DeployStatus.OPERATION_INPROGRESS
  ];

  filterStartDate: any;
  filterEndDate: any;

  filterStartDateUpdateTab: any;
  filterEndDateUpdateTab: any;

  filteredDeploymentLog: any;
  filteredUpdateLog: any;
  actionOptions = [];
  activityDropdownsList: any;
  selectedActions = [];
  previousSelectedActions = [];
  isActivityInProgress: any;
  isComponentAvailable = false;
  activeComponents: any;
  externalPackages: any;
  dataSourceInnerImages: any;
  dataSourceInnerPackages: any;
  tableColumns: string[] = ['menu', 'component', 'arrow'];
  innerTableColumns: string[] = ['name', 'path', 'version'];
  type: any;
  showResultsPagination: boolean;
  configurationLoaded = false;
  permissions = Permissions;
  PermissionKeys = PermissionKeys;
  INSTANCE_DELETE_DATAZONE_NONPII: any;
  totalInstance: any;
  testResults: any;
  dataSourceTestResults: any;
  instanceEnvironment = InstanceEnvironment;
  isIFTestInprogress = false;
  installationSpecificationForms: any;
  dataSourceEFTestResults: any;
  dataSourceSanityTestResults: any;
  efTestResults: any;
  sanityTestResults: any;
  testResultsTotal = 0;
  dataLoaded = false;
  isEFTestInprogress = false;
  isSanityTestInprogress = false;
  sanityTest = false;
  efTest = false;
  clientName: any;
  instanceId: any;
  backupTable: any = [];
  backupTableColumns = ['databaseName', 'applicationStartTime', 'expiryDays', 'pitrTimestamp', 'ticketNumber', 'initiatedBy', 'status', 'delete'];
  isBackupTableLoaded: boolean;
  backupResults: any = [];
  searchText: string;
  dbFilterRecord: any;
  databases: any;
  routes: any = [];
  keys: any = [];
  kubernetesName: any;
  dbStatusFilter = [
    {
      name: 'Completed',
      value: 'completed',
      selected: false
    },
    {
      name: 'Expired',
      value: 'expired',
      selected: false
    },
    {
      name: 'In progress',
      value: 'inprogress',
      selected: false
    },
    {
      name: 'failed',
      value: 'failed',
      selected: false
    },
    {
      name: 'deleted',
      value: 'deleted',
      selected: false
    },
    {
      name: 'deleting',
      value: 'deleting',
      selected: false
    },
    {
      name: 'delete failed',
      value: 'delete_failed',
      selected: false
    }
  ]

  dbTypeFilter = [
    {
      name: 'Snapshot',
      value: 'snapshot',
      selected: false
    },
    {
      name: 'Archive',
      value: 'archive',
      selected: false
    }
  ]

  dbNameFilter = [
    {
      name: 'Month End',
      value: 'monthEnd',
      selected: false
    },
    {
      name: 'Year End',
      value: 'yearEnd',
      selected: false
    },
    {
      name: 'Adhoc',
      value: 'adhoc',
      selected: false
    }
  ]
  dbFilter: any;

  displayColumns = [
    {
      key: 'arrowClick',
      name: '',
      type: 'expand',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'routeName',
      name: translate('INSTANCE_DETAILS.ROUTE_NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'routeId',
      name: translate('INSTANCE_DETAILS.ROUTE_ID'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'direction',
      name: translate('INSTANCE_DETAILS.DIRECTION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'encEnabled',
      name: translate('INSTANCE_DETAILS.ENCRYPTION'),
      type: 'text',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('INSTANCE_DETAILS.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'sftp',
      name: '',
      type: 'button',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'sftpSettings',
      name: '',
      type: 'settings'
    }
  ];

  encKeyDisplayColumns = [
     {
      key: 'name',
      name: translate('INSTANCE_DETAILS.KEY_NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'publicKey',
      name: translate('INSTANCE_DETAILS.KEY'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'expirationDate',
      name: translate('INSTANCE_DETAILS.EXPIRY_DATE_UTC'),
      type: 'dateWithoutTime',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('INSTANCE_DETAILS.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'sftpKeySettings',
      name: '',
      type: 'settings'
    }
  ];
  inventoryColumns = [
    {
      key: 'name',
      name: translate('TENANT_DETAILS.CLOUD_NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'type',
      name: translate('TENANT_DETAILS.CLOUD_TYPE'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'kind',
      name: translate('TENANT_DETAILS.CLOUD_KIND'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'skuData',
      name: translate('TENANT_DETAILS.CLOUD_SKU'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'cloudInventorySettings',
      name: '',
      type: 'cloudInventorySettings'
    }
  ];
  inventoryProductColumns = [
    {
      key: 'name',
      name: translate('INSTANCE_DETAILS.NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
    key: 'version',
    name: translate('INSTANCE_DETAILS.VERSION'),
    type: 'text',
    sortable: true,
    visible: true,
    disable: true
    },
    {
      key: 'image',
      name: translate('INSTANCE_DETAILS.IMAGE'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'workload',
      name: translate('INSTANCE_DETAILS.WORK_LOAD'),
      type: 'text',
      sortable: true,
      visible: false,
      disable: false
    },
    {
      key: 'isManaged',
      name: translate('INSTANCE_DETAILS.IS_MANAGED'),
      type: 'text',
      sortable: true,
      visible: false,
      disable: false
    },
    {
      key: 'InventoryProductSettings',
      name: '',
      type: 'InventoryProductSettings'
    }
  ];

  readonly DR_STATES = [DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED];

  readonly EXCECUTETEST_ENABLE_STATES = [
    DeployStatus.DEPLOYED,
    DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED,
    DeployStatus.CONFIGURED,
    DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.TESTED,
    DeployStatus.FAILOVER_FAILED,
    DeployStatus.FAILBACK_FAILED,
    DeployStatus.PRE_FAILBACK_FAILED,
    DeployStatus.POST_FAILBACK_FAILED,
    DeployStatus.STOP_FAILED
  ];
  readonly COB_ENABLE_STATES = [
    DeployStatus.DEPLOYED,
    DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED,
    DeployStatus.CONFIGURED,
    DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.TESTED,
    DeployStatus.TEST_FAILED,
  ];
  readonly INITIAL_STATES = [
    DeployStatus.INITIALIZED,
    DeployStatus.INITIALIZE_FAILED,
    DeployStatus.INITIALIZING
  ];
  readonly INSTANCE_AVAILABLE_STATUS = [DeployStatus.DEPLOYED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TESTED, DeployStatus.TEST_FAILED,
    DeployStatus.CONFIGURED, DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.FAILED, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.INITIALIZING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INPROGRESS];
  readonly WARNING_STATUS =[DeployStatus.FAILED, DeployStatus.UPDATE_FAILED];
    keyDisabledStatus = [DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.OPERATION_INPROGRESS,
      DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.STARTING,
      DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED];

readonly INSTANCE_DEPLOYING_STATUS = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TERMINATION_FAILED,
    DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING];
  cobResults: any;
  sch1: string;
  sch2: string;
  cobTable: any;
  dataSourceCob: any;
  dataSourceInnerCob: any;
  isCobLoaded: boolean;
  dbDropdownsList:any;
  dbStatus: any;
  showLoader = false;
  dataSourceDb: any;
  dbPaginator: any;
  dbPaginationSize = 10;
  dbInprogess = false;
  allRvtStates: any;
  selectedRvtFilter = {
    label: 'All',
    value: ''
  };
  rvtStates: any;
  filteredRvtStates: any;
  rvtSearchTerm: any;
  pageRvtStates: any;
  rvtSort: any;
  selectedRvtTab = 0;
  configurationsForRvt: any;
  executeRvtInProgress = false;
  rvtResultsLoaded = false;
  appliedRvtState: any;
  rvtPaginatioSize = 5;
  rvtPageIndex = 0;
  dbError: any;
  dbFilterTags: any;
  adoPipelineUrl: any;
  adoProjectName: any;
  initialRouteData: any;
  sftpLoader = true;
  encKeys: any;
  initialEncKeys = [];
  encKeyLoader = true;
  encDropdownsList: any;
  encFilteredColumns: any;
  encFilterStartDate: any;
  encFilterEndDate: any;
  date: any;
  cloudResourceLoader = true;
  cloud: boolean;
  cloudPaginator: boolean;
  CloudPaginationSize: number;
  cloudResourceData: any;
  searchedResult: any;
  InventoryCloudDropdownList: any;
  typeOptions: any;
  types: any;
  selectedType: any[];
  initialCloudResourceData: any;
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  components: boolean;
  inventoryData: any;
  inventoryComponentData: any;
  inventoryComponents: any;
  searchInventoryTerm: string;
  inventoryLoading = true;
  searchedComponentResult = [];
  componentStatus: any;
  selectedStatus = [];
  ComponentFilter : any;
  componentFilterOptions : any;
  expiryDateDropdownsList: any;
  routeSearchTerm: string;
  keySearchTerm: string;
  filteredRouteData: any = [];
  kubernetes:boolean;
  products:boolean;
  inventoryKubernetesData:any;
  inventoryKubernetes:any;
  searchedKubernetesRes:any;
  searchKubTerm:any;
  searchProductTerm:any;
  inventoryProductsData:any;
  inventoryProducts:any;
  inventoryProdDropdown:any;
  prodVersionOptions:any;
  prodIsManagedOptions:any;
  selectedProdVersion: any[];
  productVersions:any;
  prodIsManaged:any;
  filteredProdColumns:any;
  filteredIsManagedColumns:any;
  isProdFilterResultEmpty = false;
  searchedProductsRes:any;
  selectedIsManaged: any;
  showWarningPopup: boolean;
  selectedVersion:any[];
  inventoryComponentColumns = [
    {
      key: 'name',
      name: translate('INSTANCE_DETAILS.NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'version',
      name: translate('INSTANCE_DETAILS.VERSION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'status',
      name: translate('INSTANCE_DETAILS.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: false,
    },
  ];

inventoryKubernetesColumns = [
  {
    key: 'name',
    name: translate('TENANT_DETAILS.NAME_SPACE'),
    type: 'text',
    sortable: true,
    visible: true,
    disable: true
  },
  {
    key: 'details',
    name: "",
    type: 'descriptionIcon',
    visible: true,
    disable: false
  }]
  sftpEncKeyRotation = false;
  metricsDisplayColumns = [
    {
      key: 'action',
      name: translate('INSTANCE_DETAILS.ACTION'),
      type: 'text',
      sortable: true,
      visible: true
    },
    {
      key: 'startTime',
      name: translate('INSTANCE_DETAILS.START_TIME'),
      type: 'date',
      sortable: true,
      visible: true
    },
    {
      key: 'finishTime',
      name: translate('INSTANCE_DETAILS.END_TIME'),
      type: 'date',
      sortable: true,
      visible: true
    },{
      key: 'totalDuration',
      name: translate('INSTANCE_DETAILS.TOTAL_DURATION'),
      type: 'duration',
      sortable: true,
      visible: true,
    },
  ];
  metricsLog: any;
  metricsSearchTerm: any;
  successConfigStates = [];
  metricsPieChartLoaded: boolean;
  metricsPiechart: any;
  hasSecondaryRegion: any;
  metricFilter = [];
  metricActionOptions = [];
  metricAction: any;
  selectedMetricAction: any;
  metricLogData: any;
  metricStartDate: any;
  metricEndDate: any;
  searchedMetricResult = [];
  metricMonth= new Date();
  metricResponse : any;
  configurationStateResponse : any;
  configurationMonth : any;
  selectedMetricInstance: any;
  metricTimePieMonth:any;
  isAWS: boolean;
  availableConfigLoaded = false;
  logConfigUserGuide: string;
  isInprogress: boolean;
  constructor(private dateTimeService: DateTimeService, private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorPageService: ErrorPageService,
    private blueprintsService: BlueprintsService,
    private configService: ConfigurationsService,
    private crvtService: CRVTService,
    private changeDetectorRef: ChangeDetectorRef,
    private notificationsService: NotificationsService,
    private solutionVersionsService: SolutionVersionsService,
    private timeDuration: TimeDurationPipe,
    private durationPipe: DurationPipe,
    private capitalizeFirst: CapitalizeFirstPipe,
    public urlService: UrlService, private toastrService: CustomToastrService, private clipboardApi: ClipboardService,public dateTimeFormatService: DateTimeFormatService,
     private instanceService: InstancesService, private sidenavService: SidenavService, private tenantService: TenantService,
      private dialog: MatDialog, private sweetAlertService: SweetAlertService, private toastrErrorService: ToastrErrorService, private cdr: ChangeDetectorRef,
      public datePipe: DatePipe, private permissionsService: PermissionsService, private componentFactoryResolver: ComponentFactoryResolver, private solutionsService: SolutionsService, private route: ActivatedRoute,
      private installationSpecificationService: InstallationSpecificationService,private formBuilder: FormBuilder, private cobService: CobService, private backupService: BackupService,
      public inventoryService: InventoryService,
      private featurePermissionsService: FeaturePermissionsService,private dbBackupService: DbbackupService, public schedulerService: SchedulerService, private activityService: ActivityService) {
    
   }

  ngOnInit(): void {
  this.instanceId = this.route.snapshot.params.instanceId;
  this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
  if (this.COB_ENABLE_STATES.includes(this.data?.status)) {
    this.isCobLoaded = true;
  }
  this.componentFilterOptions = [
    { value: 'Success', selected: false ,label: "Success"},
    { value: 'Failed', selected: false,label: "Failed" },
  ];
  this.ComponentFilter =[ {
    title: 'Status',
    placeholder: 'Select Status',
    options: this.componentFilterOptions,
  }]
  if (localStorage.getItem('filteredComponentStatus')) {
    this.componentStatus = JSON.parse(localStorage.getItem('filteredComponentStatus'));
    if (this.componentStatus) {
      this.selectedStatus = this.componentStatus;
      this.componentStatus = this.selectedStatus;
      this.ComponentFilter[0]?.options.forEach((element) => {
      if (this.selectedStatus.find((item) => item === element.value)) {element.selected = true;}
    });
  }}
  this.metricFilter = [
      { title: 'Action', placeholder: 'Select Action' },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: { value: 'Date', selected: false },
      },
  ];
  this.metricStartDate = localStorage.getItem('filteredMetricStartDate') ? localStorage.getItem('filteredMetricStartDate') : '';
  this.metricEndDate = localStorage.getItem('filteredMetricEndDate') ? localStorage.getItem('filteredMetricEndDate') : '';
  this.inventoryDetailsCloud();
  this.cobResultsTable();
    this.clientName = this.router.url.split('.')[0].split('/')[3];
    this.paginator?.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      this.applyPaginator();
    });
    this.updateEnvironment(this.data);
    /*
    Sample code for validating the permission.
    Update the below code for add route and ssh key once the update available for permission map from engine
    this.INSTANCE_DELETE_DATAZONE_NONPII = this.permissionsService.permissionByDatazone(Permissions.INSTANCE_DELETE_DATAZONE_NONPII, Datazone.NONPII);
    */
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.currentEnvironment = (window.location.href.split('.')[0].split('/')[2] === 'dev' ?
     'https://dev.portal.saas.temenos.cloud/' : window.location.href.split('.')[0].split('/')[2] === 'preprod' ?
      'https://preprod.portal.saas.temenos.cloud/' : window.location.href.split('.')[0].split('/')[2] === 'utp' ?
      'https://utp.portal.saas.temenos.cloud/': 'https://portal.bankingcloud.temenos.com/');
      const statusFilteredData = localStorage.getItem('filteredSftpStatus');
      const directionFilteredData = localStorage.getItem('filteredDirection');
    if(statusFilteredData !== undefined){
      this.status = statusFilteredData;
    }
    if(directionFilteredData !== undefined){
      this.direction = directionFilteredData;
    }
    const directionOptions = [ {value: 'inbound' , selected: false},
    {value: 'outbound' , selected: false}
   ];
   const dbStatusOptions = [ {value: 'completed' , selected: false}, {value: 'expired' , selected: false}, {value: 'inprogress' , selected: false},
    {value: 'failed' , selected: false}, {value: 'deleted' , selected: false}, {value: 'deleting' , selected: false}, {value: 'delete_failed' , selected: false}
   ];
    const statusOptions = [
      {value: 'adding' , selected: false},
      {value: 'added' , selected: false},
      {value: 'failed' , selected: false},
      {value: 'removing' , selected: false},
      {value: 'removed' , selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Direction',
        placeholder: 'Select Direction',
        options: directionOptions
      },
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: statusOptions
      }
    ];
      this.dbDropdownsList = [
        {
          title: 'Status',
          placeholder: 'Select Status',
          options: this.dbStatusFilter
        },
        {
          title: 'DB Type',
          placeholder: 'Select DB Type',
          options: this.dbTypeFilter
        },
        {
          title: 'Name',
          placeholder: 'Select Name',
          options: this.dbNameFilter
        }
      ];
 
    this.clearData = true;
    this.instanceDetailsKeys = [
      {
        key: this.data.id,
        name: 'INSTANCE_DETAILS.INSTANCE_ID',
        copy: true,
        url: true
      },
      {
        key: this.data.randomSuffix,
        name: 'INSTANCE_DETAILS.RANDOM_SUFFIX',
        copy: true
      },
      {
        key: this.data.deploymentClass,
        name: 'INSTANCE_DETAILS.DEPLOYMENT_CLASS'
      },
      {
        key: this.data.dataZone,
        name: 'INSTANCE_DETAILS.DATA_ZONE'
      },
      {
        key: this.data.primaryCloudRegion || this.data.primaryRegion,
        name: 'INSTANCE_DETAILS.PRIMARY_CLOUD_REGION'
      },
      {
        key: this.data.secondaryCloudRegion || this.data.secondaryRegion,
        name: 'INSTANCE_DETAILS.SECONDARY_CLOUD_REGION'
      },
      {
        key: this.data.managementType,
        name: 'INSTANCE_DETAILS.MANAGEMENT_TYPE'
      },
      {
        key: this.data.externalOrigination,
        name: 'INSTANCE_DETAILS.EXTERNAL_ORIGINATION'
      },
      {
        key: this.data?.blueprintName,
        name: 'INSTANCE_DETAILS.SERVICE_DEFINITION_NAME'
      },
      {
        key: this.data.blueprintId,
        name: 'INSTANCE_DETAILS.SERVICE_DEFINITION_ID',
        copy: true,
        url: true
      },
      {
        key: this.data.blueprintVersionId,
        name: 'INSTANCE_DETAILS.SERVICE_DEFINITION_VERSION_ID',
        copy: true
      },
      {
        key: this.data.latestDeploymentId,
        name: 'INSTANCE_DETAILS.DEPLOYMENT_ID',
        copy: true
      },
      {
        key: this.data.configurationId,
        name: 'INSTANCE_DETAILS.CONFIGURATION_ID',
        copy: true
      }
    ];
    this.activityDropdownsList = [
      {
        title: 'Action',
      },
      {
        title: 'Date',
      }
    ];

     this.instanceService.getInstanceById(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
        const logLevel = data.parameters?.logLevel || 'INFO';
         this.isInprogress = this.INSTANCE_DEPLOYING_STATUS.includes(data.status);
        this.type = [
          {label: translate('INSTANCE_LIST.INFO'), selected: logLevel === 'INFO', disabled: this.isInprogress, message: translate('INSTANCE_LIST.INFO_MESSAGE')},
          {label: translate('INSTANCE_LIST.DEBUG'), selected: logLevel === 'DEBUG', disabled: this.isInprogress,message: translate('INSTANCE_LIST.DEBUG_MESSAGE')},
        ];
        }
      });
    this.initialLoad();
  //   let data: any = {
  //     id : this.instanceId,
  //     parameters: {
  //       logLevel: "INFO"
  //     }
  // };
  // this.onLogDataChange(data);
  if(this.logLevel !== undefined){
    const params = this.logLevel
    let data: any = {
      id: this.instanceId,
      parameters: {
        logLevel: params?.logLevel
      }
    };
    // this.onLogDataChange(data);
    let logObj;
    let logArr = [];
    params.logLevel = "INFO";
    this.type.filter(x => {
      if (x.label === this.toTitleCase(params?.logLevel)) {
        logObj = { label: x.label, selected: true, message: x.message, disabled:x.disabled, edit: true };
      }else{
        logObj = { label: x.label, selected: false, message: x.message, disabled:x.disabled, edit: true };
      }
      logArr.push(logObj)
    })

    this.type = logArr;
    this.logConfigUserGuide = `${window.location.protocol}//${window.location.hostname}/userguide/docs/tenant-view/configure-the-environments/log-level-configuration`;
  }

  const date = [
      {value: 'Expiry Date', selected: false}
    ];
    this.expiryDateDropdownsList = [
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: date
      }
    ];
    if(this.data?.endpoints) {
      this.configTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.CONFIGURATION);
      this.accessTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.UI);
      this.exploreTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.API);
      this.otherTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.OTHER);
      if (this.configTypeEndpoints.length > 0
        || this.accessTypeEndpoints.length > 0
        || this.exploreTypeEndpoints.length > 0
        || this.otherTypeEndpoints.length > 0) {
        this.isEndpointAvailable = true;
      }
    }
    if (localStorage.getItem('filteredEncKeyDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredEncKeyDate'));
      if (dateData) {
        this.date = dateData;
        this.expiryDateDropdownsList[0].options.forEach(element => {
          if(dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.encFilterStartDate = localStorage.getItem('filteredEncKeyStartDate') ? localStorage.getItem('filteredEncKeyStartDate'): '';
    this.encFilterEndDate = localStorage.getItem('filteredEncKeyEndDate') ? localStorage.getItem('filteredEncKeyEndDate'): '';
    this.activityService.getInstanceActivityLogs(this.data.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.showSpinner = false;
        this.showActivityLoader = false;
        this.isLogFailed = true;
        this.metricResponse = data;
        this.metricsLog = data.filter(item => {
          const itemDate = new Date(item.startTime);
          return itemDate.getFullYear() === this.metricMonth.getFullYear() && itemDate.getMonth() === this.metricMonth.getMonth();
        });
        this.metricLogData = this.metricsLog;
        this.metricResponse?.forEach((item) => {
          if (!this.metricActionOptions.find((option) => option.value === item.action) && item.action !== '' && item.action !== undefined) {
              const actionOption = {
                value: item.action,
                selected: false,
                label: item.action,
              };
              this.metricActionOptions = [...this.metricActionOptions,actionOption];
            }
            this.metricFilter[0].options = this.metricActionOptions;
          });
        if (localStorage.getItem('filteredMetricAction')) {
          this.metricAction = JSON.parse(localStorage.getItem('filteredMetricAction'));
          if (this.metricAction) {
            this.selectedMetricAction = this.metricAction;
            this.metricAction = this.selectedMetricAction;
            this.metricFilter[0]?.options.forEach((element) => {
              if (this.selectedMetricAction.find((item) => item === element.value)) {
                element.selected = true;
              }
            });
          }
        }
        if(this.WARNING_STATUS.includes(this.data?.status)){
        const latestAction = data.filter(log => log?.status === 'failed' && ((log?.action === 'config' && this.data?.status === DeployStatus.FAILED) || (log?.action === 'update' && this.data?.status === DeployStatus.UPDATE_FAILED))).sort((a, b) =>
         new Date(b?.startTime).getTime() -new Date(a?.startTime).getTime())[0];
        this.showWarningPopup = !!latestAction;
        }
        this.initialMetricItems();
        this.logData = data;
        this.deploymentLogData = this.logData;
        this.dataSourceLog = this.deploymentLogData;
        // if (this.data.status === DeployStatus.DEPLOYING && this.logData?.length === 0) {
        //   this.data.status = DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS;
        // }
        let index = -1;
        this.logData?.forEach(item => {
          index = index+1;
          const activityLog = true;
          if(item?.action === 'start' && this.logData[index-1]?.action === 'stop') {
            item.shutdown = this.timeDuration.transform(item.startTime, this.logData[index-1].finishTime, undefined, activityLog);
          }
        });
        const latestRecord = data.sort((a, b) => (a.startTime > b.startTime) ? -1 : 1)[0];
        this.isComponentAvailable = latestRecord?.components?.length > 0? true : false;
        if (latestRecord?.status == 'inprogress') {
          const component = latestRecord?.components;
          this.isActivityInProgress = component?.filter(item=> item.status == 'inprogress');
          this.activeComponents = latestRecord?.components?.sort((a, b) => (a.start > b.start) ? -1 : 1);
        }
        this.logData?.forEach(item => {
          if (!this.actionOptions.find(option => option.value === item.action)) {
            const actionOption = {
              value: item.action,
              selected: false
            }
            this.actionOptions = [...this.actionOptions, actionOption];
          }
          this.activityDropdownsList[0].options = this.actionOptions;
        })
      },
      (error) => {
        this.showSpinner = false;
        this.isLogFailed = true;
        this.showActivityLoader = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    this.logData?.forEach(data => data.arrowClick = false);
    if (this.data?.packageReferenceId) {
      this.getExternalPackages();
    }
    this.getTenantDetails();
    this.getTestResults(this.data.id);
    this.testTabs();
    this.getDatabases();
    this.getEncKeys();
    this.loadRoutesWithKeyExpiration();
 }

  ngAfterViewChecked(){
    this.cdr.detectChanges();
 }

 inventoryDetailsCloud(): void {
  this.searchInventoryTerm = '';
  this.searchKubTerm = '';
  this.searchTerm='';
  this.searchProductTerm = '';
  this.showLoader = true;
  this.inventoryService.getInventoryByInstance(this.instanceId)
  .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      const data = result?.inventories? result.inventories[0] : undefined;
      if(data &&  data.discoveryTable?.rows?.length > 0){
      this.inventoryComponentData =data?.discoveryTable?.rows.map((obj) => ({...obj,name: obj.component,}));
      this.inventoryComponents = this.inventoryComponentData;
      }
      if (this.componentStatus?.length) {
        this.inventoryComponents = this.inventoryComponentData?.filter((item) => this.selectedStatus?.includes(item?.status));
      }
      if (data && data.compute?.length > 0) {
        // Kubernetes model to restructure the json
        this.kubernetesName = data.compute[0]?.name;
        this.inventoryKubernetesData = KubernetesResource.transformResourcesAllNamespaces(data.compute[0]?.resources);
        this.inventoryKubernetes = this.inventoryKubernetesData;
      }
      if(data && data.products?.length > 0){
      this.inventoryProductsData =data?.products?.map((obj) => ({...obj,name: obj.product,isManaged: obj.isManaged === 'true' ? 'Yes' : 'No',}));
      this.inventoryProducts = this.inventoryProductsData;
      }
      this.inventoryLoading = false;
      this.showLoader = false;
      this.cloudResourceData = data?.infra?.resources;
      this.initialCloudResourceData = data?.infra?.resources;
      this.cloudResourceLoader = false;
      this.cloudResourceData?.forEach(item => {
        item.skuData = item?.sku?.name ? item?.sku?.name : '-';
      });
      this.handleInventoryProductData();
      const types = this.cloudResourceData?.map(item => item.type);
      const uniqueArray = [...new Set(types)];
      const outputArray = this.transformArray(uniqueArray);
      this.typeOptions = outputArray;
      this.InventoryCloudDropdownList = [
        {
          title: 'Type',
          placeholder: 'Select Type',
          options: this.typeOptions
        }
      ];
      if (localStorage.getItem('inventoryCloudFiltered')) {
        const filteredColumns = JSON.parse(localStorage.getItem('inventoryCloudFiltered'));
        this.filteredColumns = [filteredColumns];
        if (filteredColumns) {
          this.selectedType = filteredColumns;
          this.status = this.selectedType;
          this.InventoryCloudDropdownList[0].options.forEach(element => {
            if(this.selectedType.find(item=> item === element.value)) {
              element.selected = true;
            }
          });
        }
      }
      this.initialProductFilterItems();
      this.initialFilterItems();
    },
    (error) => {
      this.showSpinner = false;
      this.cloudResourceLoader = false;
      this.inventoryLoading = false;
      this.showLoader = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
 }

 handleInventoryProductData(){
  const versions = this.inventoryProductsData?.map((item) => item.version);
  const versionsArray = [...new Set(versions)];
  const outputVersionsArray: any = this.transformArray(versionsArray);
  this.prodVersionOptions = outputVersionsArray.sort((a, b) => {
    const aVal = parseInt(a.value.split('.')[0], 10);
    const bVal = parseInt(b.value.split('.')[0], 10);
    return aVal - bVal;
  });
  this.prodIsManagedOptions = [
    { value: 'Yes', label: 'Temenos', selected: false },
    { value: 'No', label: 'Third Party', selected: false },
  ];
  this.inventoryProdDropdown = [
    {
      title: 'Version',
      placeholder: 'Select Version',
      options: this.prodVersionOptions,
    },
    {
      title: 'Managed By',
      placeholder: 'Select Managed By',
      options: this.prodIsManagedOptions,
    },
  ];
  if (localStorage.getItem('prodVersionsFiltered')) {
    const filteredColumns = JSON.parse(
      localStorage.getItem('prodVersionsFiltered')
    );
    this.filteredProdColumns = [filteredColumns];
    if (filteredColumns) {
      this.selectedVersion = filteredColumns;
      this.productVersions = this.selectedVersion;
      this.inventoryProdDropdown[0].options.forEach((element) => {
        if (this.selectedVersion.find((item) => item === element.value)) {
          element.selected = true;
        }
      });
    }
  }
  if (localStorage.getItem('prodIsManagedFiltered')) {
    const filteredColumns = JSON.parse(
      localStorage.getItem('prodIsManagedFiltered')
    );
    this.filteredIsManagedColumns = [filteredColumns];
    if (filteredColumns) {
      this.selectedIsManaged = filteredColumns;
      this.prodIsManaged = this.selectedIsManaged;
      this.inventoryProdDropdown[1].options.forEach((element) => {
        if (this.selectedIsManaged.find((item) => item === element.value)) {
          element.selected = true;
        }
      });
    }
  }
 }

 transformArray(arr): void {
  return arr.map(item => ({
    value: item,
    label: item.charAt(0).toUpperCase() + item.slice(1),
    selected: false
  }));
}

 updateEnvironment(data) {
  switch (data.deploymentClass) {
    case DeploymentClass.D:
      this.data.environment = InstanceEnvironment.DEV;
      break;
    case DeploymentClass.C:
      this.data.environment = InstanceEnvironment.TEST;
      break;
    case DeploymentClass.B:
      this.data.environment = InstanceEnvironment.PREPROD;
      break;
    case DeploymentClass.A:
      this.data.environment = InstanceEnvironment.LIVE;
      break;
  }
}

 getTenantDetails() {
  this.tenantService.getTenantDetails(this.data.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
       if(data?.parameters?.hasSecondaryRegion && (data?.parameters?.hasSecondaryRegion === 'true' || data?.parameters?.hasSecondaryRegion === true)) {
          this.hasSecondaryRegion = true;
        } else if(!data?.parameters?.hasSecondaryRegion) {
          this.hasSecondaryRegion = true;
        } else {
          this.hasSecondaryRegion = false;
        }
    if(data?.sharedServices?.pii?.sftpEncKeyRotation && (data?.sharedServices?.pii?.sftpEncKeyRotation === true || data?.sharedServices?.pii?.sftpEncKeyRotation === 'true')) {
        this.sftpEncKeyRotation = true;
      } else {
        this.sftpEncKeyRotation = false;
      }
      this.data.managementType = data.managementType;
      this.adoPipelineUrl = data?.adoPipelineUrl;
      this.adoProjectName = data?.adoProjectName;
    });
}

selectOptionsType(item?: any): void {
  this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.SETTINGS_TITLE'),
            message: `${translate('INSTANCE_DETAILS.SETTINGS_MESSAGE')} "${item.label.toUpperCase()}"`,
            confirmButtonText: translate('DIALOG.CONFIRM')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
              if(this.type) {
              for (const items of this.type) {
                if (items.selected) {
                  items.selected = false;
                }
              }
            }
            if(item) {
            item.selected = !item.selected;
            };

            let data: any = {
              id : this.instanceId,
              parameters: {
                logLevel: item.label.toUpperCase()
              }
          };
          this.onLogDataChange(data);
          }
  })
}


toTitleCase(log?: any) {
  if (!log || typeof log !== 'string') return '';
  return log?.toLowerCase().split(' ').map((word: any) => {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}

onLogDataChange(data): void {
  this.instanceService.sendingLogBasedOnSelection(data);
}

  onTabChange($event: { index: number }) {
    if ($event.index !== 4 && $event.index !== 8) {
      setTimeout(() => {
        if (document.getElementsByClassName("cdk-overlay-container")) {
          const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
          if (element) {
            element.style.display = 'block';
          }
        }
      }, 100);
    }
    this.activeTab = 0;
    if ($event.index === 6) {
      this.isRvtPack = true;
    } else {
      this.isRvtPack = false;
    }
    if ($event.index === 4) {
      this.deploymentLog = false;
      this.sftpPaginator = false;
      this.logPaginator = false;
      this.viewResultsPaginator = false;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = false;
    } else if($event.index === 5) {
      this.sftpPaginator = false;
      this.logPaginator = false;
      this.viewResultsPaginator = true;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = false;
    } else if($event.index === 9) {
      this.onLogTabChange($event);
      this.sftpPaginator = false;
      this.logPaginator = true;
      this.viewResultsPaginator = false;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = false;
      this.pageIndex = 0;
    }else if($event.index === 10) {
      this.onLogTabChange($event);
      this.sftpPaginator = false;
      this.logPaginator = false;
      this.viewResultsPaginator = false;
      this.dbPaginator = false;
      if (this.efTest) {
        this.sanityPaginator = false;
        this.EFPaginator = true;
        this.pageIndex = 0;
        this.dataSourceEFTestResults = new MatTableDataSource(this.efTestResults?.slice(0, 0 + 10));
      } else {
        this.EFPaginator = false;
        this.sanityPaginator = true;
        this.pageIndex = 0;
        this.dataSourceSanityTestResults = new MatTableDataSource(this.sanityTestResults?.slice(0, 0 + 10));
      }
    } else if($event.index === 11) {
      this.onLogTabChange($event);
      this.sftpPaginator = false;
      this.logPaginator = false;
      this.viewResultsPaginator = false;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = false;
      this.pageIndex = 0;
      this.dataSourceCob = new MatTableDataSource(this.cobTable?.slice(0, 0 + 10));
    } else if ($event.index === 12) {
      this.sftpPaginator = false;
      this.logPaginator = false;
      this.viewResultsPaginator = false;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = true;
      this.pageIndex = 0;
      this.dataSourceDb = new MatTableDataSource(this.backupTable?.slice(0, 0 + this.dbPaginationSize));
    } else if ($event.index === 13) {
      this.sftpPaginator = false;
      this.logPaginator = false;
      this.viewResultsPaginator = false;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = true;
      this.cloudPaginator = true;
      this.pageIndex = 0;
    } else {
      this.logPaginator = false;
      this.sftpPaginator = false;
      this.viewResultsPaginator = false;
      this.sanityPaginator = false;
      this.EFPaginator = false;
      this.dbPaginator = false;
    }
  }

  onLogTabChange($event?: { index: number }): any {
  if ($event.index === 0 || $event.index === 9) {
    this.deploymentLogData = this.logData;
    if (this.selectedActions?.length > 0) {
      this.deploymentLogData = this.logData?.filter(item => this.selectedActions?.includes(item?.action));
    } else {
      this.deploymentLogData = this.logData;
    }
    if (this.filterStartDate && this.filterEndDate) {
      this.deploymentLogData = this.deploymentLogData.filter(item => this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
      this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
    }
    this.dataSourceLog = this.deploymentLogData;
    this.deploymentLog = true;
    if (this.sortInfo) {
      const sortedData = this.sortDeployData(this.sortInfo);
      this.dataSourceLog = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      const sortedData =  this.sortDeployData({active: 'startTime', direction: 'desc'});
      this.dataSourceLog = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    }
  } else {
    this.updatedLogData = this.logData?.filter(data => data.action === translate('INSTANCE_STATUS.UPDATE'));
    this.dataSourceUpdateLog = this.updatedLogData;
    this.deploymentLog = false;
    this.updatedLog = true;
    if (this.sortInfo) {
      const sortedData = this.sortDeployData(this.sortInfo);
      this.dataSourceUpdateLog = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      const sortedData =  this.sortDeployData({active: 'startTime', direction: 'desc'});
      this.dataSourceUpdateLog = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    }
 }
}

  onRouteArrowClick(data): void {
    this.routeExpandedElement = this.routeExpandedElement === data ? null : data;
    this.dataSource.filteredData.find(item => item.routeId === data.routeId).arrowClick = !this.dataSource.filteredData.find(item => item.routeId === data.routeId).arrowClick;
    this.dataSource.filteredData.forEach(item =>  {
      if(item.routeId !== data.routeId) {
        item.arrowClick = false;
      }
    });
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        element.style.display = 'none';
      }
    }, 200);
  }

  onArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.dataSourceLog.filteredData.find(item => item.contextId === data.contextId).arrowClick = !this.dataSourceLog.filteredData.find(item => item.contextId === data.contextId).arrowClick;
    this.dataSourceLog.filteredData.forEach(item =>  {
      if(item.contextId !== data.contextId) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInnerLog = this.dataSourceLog.filteredData.find(item => item.contextId === data.contextId).components;
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        element.style.display = this.expandedElement ? 'none' : 'block';
      }
    }, 200);
  }

  onUpdateArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.dataSourceUpdateLog.filteredData.find(item => item.contextId === data.contextId).arrowClick = !this.dataSourceUpdateLog.filteredData.find(item => item.contextId === data.contextId).arrowClick;
    this.dataSourceUpdateLog.filteredData.forEach(item =>  {
      if(item.contextId !== data.contextId) {
        item.arrowClick = false;
      }
    });
    this.dataSourceUpdateInnerLog = this.dataSourceUpdateLog.filteredData.find(item => item.contextId === data.contextId).components;
  }

  initialLoad(): void {
    this.sftpLoader = true;
    this.isFailed = false;
    this.routeData = [];
    this.loadData(this.routeData);
    if(this.direction) {
      localStorage.setItem('filteredDirection', this.direction);
      } else {
        localStorage.removeItem('filteredDirection');
      }
    if(this.status) {
      localStorage.setItem('filteredSftpStatus', this.status);
    } else {
      localStorage.removeItem('filteredSftpStatus');
    }
    if(this.data.name === 'Demo Instance') {
      this.sftp = false;
    } else {
      this.sftp = true;
    }
    this.instanceService.getInstanceDetailsSftpDetailsById(this.data.id, this.direction ? this.direction : undefined, this.status ? this.status : undefined)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.sftpLoader = false;
        this.isFailed = true;
        if (this.keys && this.keys.length > 0) {
          data = data.map((route) => {
            const matchedKey = this.keys.find(
              (key) => key.name === route.encKeyName
            );
            const formattedDate = this.dateTimeService.formatToShortDate(
              matchedKey?.expirationDate
            );
            return {
              ...route,
              encKeyName: route.encKeyName,
              encKeyExpirationDate: formattedDate,
            };
          });
        }
        this.initialRouteData = data;
        this.filterSftpData();
      },
      (error) => {
        this.sftpLoader = false;
        this.isFailed = true;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
      this.loadService();
  }

  /**
 * Loads route details and their corresponding encryption name & expiration dates.
 * This method uses `forkJoin` to parallelly fetch:
 *  - Route details for the current instance (`getInstanceDetailsSftpDetailsById`)
 *  - Encryption keys for the instance (`getEncryptionKeys`)
 */
  loadRoutesWithKeyExpiration(): void {
  forkJoin({
  routesResult: this.instanceService.getInstanceDetailsSftpDetailsById(this.data.id),
  keysResult: this.instanceService.getEncryptionKeys(this.data.id)
}).subscribe({
  next: ({ routesResult, keysResult }) => {
    this.keys = keysResult;
    this.routes = routesResult.map(route => {
      const matchedKey = this.keys.find(key => key.name === route.encKeyName);
      const formattedDate = this.dateTimeService.formatToShortDate(matchedKey?.expirationDate);
      return {
        ...route,
        encKeyName: route.encKeyName,
        encKeyExpirationDate: formattedDate
      };
    });
  },
});
}

  sortData(event): void {
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    if(this.deploymentLog) {
      this.sortInfo = event;
      if (this.filteredDeploymentLog?.length >= 0) {
        this.filteredDeploymentLog = this.sortDeployData(event, this.filteredDeploymentLog);
      } else {
        this.deploymentLogData = this.sortDeployData(event);
      }
      this.expandedElement = null;
      const data = this.filteredDeploymentLog ? this.filteredDeploymentLog : this.deploymentLogData;
      this.dataSourceLog = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    } else if(this.updatedLog) {
      this.sortInfo = event;
      if (this.filteredUpdateLog) {
        this.filteredUpdateLog = this.sortDeployData(event, this.filteredUpdateLog);
      } else {
        this.updatedLogData = this.sortDeployData(event);
      }
      this.expandedElement = null;
      const data = this.filteredUpdateLog ? this.filteredUpdateLog : this.updatedLogData;
      this.dataSourceUpdateLog = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    } else {
      this.routeData = this.sortInstanceData(event);
      this.dataSource = new MatTableDataSource(this.routeData?.slice(this.pageIndex, this.paginationSize));
    }
  }

  sortCobData(event) : void {
    this.cobTable = this.sortCobInstanceData(event);
    this.pageIndex = 0;
    const data = this.cobTable?.slice(0, 0 + this.cobPaginationSize);
    this.dataSourceCob = new MatTableDataSource(data);
  }

  sortCobInstanceData(event): void {
    return this.cobTable?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'date':
          comparatorResult = new Date(a?.cobDate)?.getTime() < new Date(b?.cobDate)?.getTime() ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  sortDbData(event): void {
    this.backupTable = this.sortDbInstanceData(event);
    this.pageIndex = 0;
    const data = this.backupTable?.slice(0, 0 + this.dbPaginationSize);
    this.dataSourceDb = new MatTableDataSource(data);
  }

  sortDbInstanceData(event): void {
    return this.backupTable?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'applicationStartTime':
          comparatorResult = new Date(a?.applicationStartTime)?.getTime() < new Date(b?.applicationStartTime)?.getTime() ? -1 : 1;
          break;
        case 'expiryDays':
          comparatorResult = new Date(a?.expiryDate)?.getTime() < new Date(b?.expiryDate)?.getTime() ? -1 : 1;
          break;
        case 'pitrTimestamp':
          comparatorResult = new Date(a?.pitrTimestamp)?.getTime() < new Date(b?.pitrTimestamp)?.getTime() ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  loadData(data): void {
    this.pageIndex = 0;
    if (this.sortInfo) {
      const sortedData = this.sortInstanceData(this.sortInfo);
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      const sortedData =  this.sortInstanceData({active: 'status', direction: 'asc'});
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    }
    this.addingStatus = true;
    if(data) {
      data.forEach(element => {
      if(element?.status === 'adding') {
        this.addingStatus = false;
      }
    });
    }
  }

  sortInstanceData(event): any {
    return this.routeData?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'routeId':
          comparatorResult = a?.routeId && b?.routeId ? a?.routeId?.localeCompare(b?.routeId) : !a?.routeId ? -1 : 1;
          break;
        case 'routeName':
          comparatorResult = a?.routeName && b?.routeName ? a?.routeName?.localeCompare(b?.routeName) : !a?.routeName ? -1 : 1;
          break;
        case 'direction':
          comparatorResult = a?.direction && b?.direction ? a?.direction?.localeCompare(b?.direction) : !a?.direction ? -1 : 1;
          break;
        case 'status':
          comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status)
            : !a?.status ? -1 : 1;
          break;
        default:
          comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status) : !a?.status ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  sortDeployData(event, filteredList?): any {
    let data;
    if(this.deploymentLog) {
    data = this.deploymentLogData;
    } else if(this.updatedLog) {
    data = this.updatedLogData;
    }
    if (filteredList) {
      data = filteredList;
    }
    return data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'startTime':
          comparatorResult = a?.startTime && b?.startTime ? a?.startTime?.localeCompare(b?.startTime) : !a?.startTime ? -1 : 1;
          break;
        case 'finishTime':
          comparatorResult = a?.finishTime && b?.finishTime ? a?.finishTime?.localeCompare(b?.finishTime) : !a?.finishTime ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  resultsChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.pageConfigurationStates.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  sanityResultsChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.sanityPaginationSize = event.pageSize;
      // this.getTestResults(this.instanceId, TestTypes.SANITY_TEST, this.pageIndex, this.sanityPaginationSize);
      const firstIndex = this.pageIndex * this.sanityPaginationSize;
      const data = this.sanityTestResults.slice(firstIndex, firstIndex + this.sanityPaginationSize);
      this.dataSourceSanityTestResults = new MatTableDataSource(data);
    }
  }

  EFResultsChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.EFPaginationSize = event.pageSize;
      // this.getTestResults(this.instanceId, TestTypes.EF_TEST, this.pageIndex, this.EFPaginationSize);
      const firstIndex = this.pageIndex * this.EFPaginationSize;
      const data = this.efTestResults.slice(firstIndex, firstIndex + this.EFPaginationSize);
      this.dataSourceEFTestResults = new MatTableDataSource(data);
    }
  }

  cobPageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.cobPaginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.cobPaginationSize;
      const data = this.cobTable?.slice(firstIndex, firstIndex + this.cobPaginationSize);
      this.dataSourceCob = new MatTableDataSource(data);
    }
  }

  dbPageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.dbPaginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.dbPaginationSize;
      const data = this.backupTable?.slice(firstIndex, firstIndex + this.dbPaginationSize);
      this.dataSourceDb = new MatTableDataSource(data);
    }
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.routeData.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  logPageChanged(event): any {
    if (event.length) {
      this.expandedElement = null;
      this.logData.forEach(item =>  {
          item.arrowClick = false;
      });
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      if(this.deploymentLog) {
        const data = this.filteredDeploymentLog ? this.filteredDeploymentLog : this.deploymentLogData;
        const dataList = data?.slice(firstIndex, firstIndex + this.paginationSize);
        this.dataSourceLog = new MatTableDataSource(dataList);
      } else {
        const data = this.filteredUpdateLog ? this.filteredUpdateLog : this.updatedLogData;
        const dataList = data?.slice(firstIndex, firstIndex + this.paginationSize);
        this.dataSourceUpdateLog = new MatTableDataSource(dataList);
      }

    }
  }

  closeMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  closeDbMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredDbColumnsFunction(data);
  }

  countSuccess(data): any {
    let count = 0;
    data?.components?.forEach(element => {
    if(element.status === translate('INSTANCE_STATUS.SUCCESS')) {
      count = count+1;
    }
  });
    return count;
  }

  countFailure(data): any {
    let count = 0;
    data?.components?.forEach(element => {
    if(element.status === translate('INSTANCE_STATUS.FAILED')) {
      count = count+1;
    }
  });
    return count;
  }

  addClassDuration(data, status): any {
    if(data.startsWith('00:')) {
      if(status === 'success') {
        this.addColor = 'green';
      } else {
        this.addColor = 'white';
      }
    } else {
      this.addColor = 'red';
    }
    return this.addColor;
  }

  filterColumns(): void {
    if(this.direction) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.value === this.direction) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.status) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[1].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.ROUTE'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      direction: this.dropdownsList[0].options,
      status: this.dropdownsList[1].options,
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          if (filteredColumns) {
            this.clearData = true;
            if(filteredColumns[0] !== '') {
              this.direction = filteredColumns[0];
            }
            if(filteredColumns[1] !== '') {
              this.status = filteredColumns[1];
            }
            this.filterSftpData();
          }
        });
  }

  dbFilterColumns(): void {
    if (this.dbStatus?.length === 0) {
      this.resetAllDbValues();
    } else {
      this.resetDbValue(this.dbStatus);
    }
    if(this.dbStatus) {
      this.dbDropdownsList[0].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.dbDropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data: any = {
      name: translate('INSTANCE_STATUS.DB'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      isMultiSelect: true,
      filteredColumns: this.dbDropdownsList,
      status: this.dbDropdownsList[0].options,
    };
      data.dbType = this.dbDropdownsList[1].options,
      data.dbName = this.dbDropdownsList[2].options
      data.dbColumns = [
        'status',
        'dbType',
        'dbName'
      ]
     this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          if (filteredColumns) {
            this.clearData = true;
            if(filteredColumns[0] !== '') {
              this.dbStatus = filteredColumns[0];
            }
            const filters = [...this.dbDropdownsList[0]?.options, ...this.dbDropdownsList[1]?.options, ...this.dbDropdownsList[2]?.options]
            this.applyFilter(filters);
          }
        });
  }

  filterCloudColumns(data) : void {
    this.InventoryCloudDropdownList[0]?.options.filter((item) => {
      if (this.types?.find(type => type === item.value)) {
        item.selected = true;
      }
    });
    const data1 = {
          name: translate('INVENTORY.INVENTORY_FILTERS'),
          title: translate('INSTANCE_STATUS.FILTER_TITLE'),
          subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
          filteredColumns: this.InventoryCloudDropdownList,
          inventoryTypeList: this.InventoryCloudDropdownList[0].options,
          inventoryColumns: [
            'type'
          ]
        };
        this.sidenavService.openInRightSidenav(ColumnFilterComponent, data1)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          this.filteredColumns = filteredColumns;
          if (filteredColumns) {
            this.clearData = true;
            if(filteredColumns[0] !== '') {
              this.types = filteredColumns[0];
            }
            if (filteredColumns[0]?.length === 0){
              this.resetInventoryFilter();
            } else {
              this.filterInventoryItems(filteredColumns);
            }
          }
        });
  }

  filterProductColumns(data) : void {
    if(this.productVersions){
    this.inventoryProdDropdown[0]?.options.filter((item) => {
      if (this.productVersions?.find(version => version === item.value)) {
        item.selected = true;
      } else{
        item.selected = false;
      }
    });
  } else {
    this.inventoryProdDropdown[0]?.options.filter((item) => {
      item.selected = false;
    });
  }

  if(this.prodIsManaged){
    this.inventoryProdDropdown[1]?.options.filter((item) => {
      if (this.prodIsManaged?.find(isManaged => isManaged === item.value)) {
        item.selected = true;
      } else{
        item.selected = false;
      }
    });
  } else {
    this.inventoryProdDropdown[1]?.options.filter((item) => {
      item.selected = false;
    });
  }



    const data1 = {
          name: translate('INVENTORY.PROD_VERSION_FILTERS'),
          title: translate('INSTANCE_STATUS.FILTER_TITLE'),
          subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
          filteredColumns: this.inventoryProdDropdown,
          inventoryProdVersionList: this.inventoryProdDropdown[0].options,
          inventoryProdIsManagedList: this.inventoryProdDropdown[1].options,
          inventoryProductColumns: [
            'version',
            'isManaged'
          ]
        };
        this.sidenavService.openInRightSidenav(ColumnFilterComponent, data1)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          this.filteredProdColumns = filteredColumns;
          if (filteredColumns) {
            this.clearData = true;
            if(filteredColumns[0] !== '') {
              this.productVersions = filteredColumns[0];
            }
            if(filteredColumns[1] !== '') {
              this.prodIsManaged = filteredColumns[1];
            }
            if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0){
              this.resetProductFilter();
            } else {
              this.filterProductItems(filteredColumns);
            }
          }
        });
  }

  filterInventoryItems(filteredColumns): void {
      if (filteredColumns) {
        this.cloudResourceData = this.initialCloudResourceData;
        this.selectedType = [];
        if (filteredColumns[0]?.length > 0) {
          this.selectedType = filteredColumns[0];
          if (filteredColumns[0].length > 0) {
            localStorage.setItem('inventoryCloudFiltered', JSON.stringify(this.selectedType));
            this.cloudResourceData = this.cloudResourceData?.filter(item => this.selectedType?.includes(item?.type));
          } else {
            localStorage.removeItem('inventoryCloudFiltered');
          }
        }
      }
    }

  filterProductItems(filteredColumns): void {
      if (filteredColumns) {
        this.inventoryProductsData = this.inventoryProducts;
        this.selectedVersion = [];
        this.selectedIsManaged = [];
        if (filteredColumns[0]?.length > 0) {
          this.selectedVersion = filteredColumns[0];
          if (filteredColumns[0].length > 0) {
            localStorage.setItem('prodVersionsFiltered', JSON.stringify(this.selectedVersion));
            this.inventoryProductsData = this.inventoryProductsData?.filter(item => this.selectedVersion?.includes(item?.version));
          } else {
            localStorage.removeItem('prodVersionsFiltered');
          }
        }
         if (filteredColumns[1]?.length > 0) {
          this.selectedIsManaged = filteredColumns[1];
          if (filteredColumns[1].length > 0) {
            localStorage.setItem('prodIsManagedFiltered', JSON.stringify(this.selectedIsManaged));
            this.inventoryProductsData = this.inventoryProductsData?.filter(item => this.selectedIsManaged?.includes(item?.isManaged));
          } else {
            localStorage.removeItem('prodIsManagedFiltered');
          }
        }
        if(this.inventoryProductsData.length == 0){
            this.isProdFilterResultEmpty = true;
          }else{
            this.isProdFilterResultEmpty = false;
          } 
      }
    }

    initialProductFilterItems() {
      this.inventoryProductsData = this.inventoryProducts;
      if (this.selectedVersion?.length > 0) {
        this.inventoryProductsData = this.inventoryProductsData?.filter(item => this.selectedVersion?.includes(item?.version));
      }
      if (this.selectedIsManaged?.length > 0) {
        this.inventoryProductsData = this.inventoryProductsData?.filter(item => this.selectedIsManaged?.includes(item?.isManaged));
      }
      if(this.inventoryProductsData?.length == 0){
          this.isProdFilterResultEmpty = true;
        }else{
          this.isProdFilterResultEmpty = false;
      }
    }

    initialFilterItems() {
      this.cloudResourceData = this.initialCloudResourceData;
      if (this.selectedType?.length > 0) {
        this.cloudResourceData = this.cloudResourceData?.filter(item => this.selectedType?.includes(item?.type));
      }
    }

    resetInventoryFilter(): void {
    this.selectedType = [];
    this.sidenavService.searchFilter.next('data');
    this.InventoryCloudDropdownList[0].options.filter((item) => {item.selected = false});
    this.types = undefined;
    this.cloudResourceData = this.initialCloudResourceData;
    localStorage.removeItem('inventoryCloudFiltered');
  }

  filteredColumnsFunction(data): void {
    if(this.direction === data) {
      this.direction = undefined;
      this.dropdownsList[0]?.options?.forEach(element => {
        element.selected = false;
      });
    } else if(this.status === data) {
      this.status = undefined;
      this.dropdownsList[1]?.options?.forEach(element => {
        element.selected = false;
      });
    }
    this.filterSftpData();
  }

  resetFilter(): void {
    this.direction = undefined;
    this.status = undefined;
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.filterSftpData();
  }

  filterSftpData(): void {
    this.routeData = this.initialRouteData;
    if (this.status) {
      this.routeData = this.routeData.filter(item => item.status === this.status);
      localStorage.setItem('filteredSftpStatus', this.status);
    } else {
      localStorage.removeItem('filteredSftpStatus');
    }
    if (this.direction) {
      this.routeData = this.routeData.filter(item => item.direction === this.direction);
      localStorage.setItem('filteredDirection', this.direction);
    } else {
      localStorage.removeItem('filteredDirection');
    }
    this.loadData(this.routeData);
    this.filteredRouteData = [...this.routeData];
  }

  filteredDbColumnsFunction(data): void {
    this.dbStatus.forEach(element => {
           if(element === this.dbFilterRecord.find(filter => filter.name === data)?.value){
            this.dbStatus = this.dbStatus.filter(item => item !== element);
            if(this.dbStatus.length > 0){
              this.resetDbValue(this.dbStatus);
            }else{
              this.dbStatus = undefined;
              this.resetAllDbValues();
            }
           }

    });
      this.applyFilter(this.dbFilter);
  }

  resetDbFilter(): void {
    this.dbStatus = undefined;
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllDbValues();
    this.applyFilter(this.dbDropdownsList);
  }

  resetAllDbValues(): void {
    this.dbDropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
   this.dbFilter.forEach(element => {
    element.selected = false;
  });
  this.dbFilterRecord.forEach(element => {
    element.selected = false;
  });
 }

 resetDbValue(data): void {
  this.dbDropdownsList.forEach(element => {
   element?.options?.forEach(item => {
     item.selected = false;
   });
 });
 this.dbFilter.forEach(element => {
  if(data?.includes(element.value)){
    element.selected = true;
  }else{
    element.selected = false;
  }
});
this.dbFilterRecord.forEach(element => {
  element.selected = false;
});
}

  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
    this.dbFilter.forEach(element => {
      element.selected = false;
    });
    this.dbFilterRecord.forEach(element => {
      element.selected = false;
    });
  }

  resetAllValues(): void {
     this.dropdownsList.forEach(element => {
      element?.options?.forEach(item => {
        item.selected = false;
      });
    });
  }

  openUrl(): void {
    const url = `${this.currentEnvironment}${this.data?.tenantId}/services/${this.data?.solutionId}/blueprints/${this.data?.blueprintId}`;
    window.open(url, '_blank');
  }

  openCobPipelineUrl(link): void {
    const url = `${link}`;
    window.open(url, '_blank');
  }

  openComponentStorageUrl(data): void {
    const url = `https://portal.azure.com/#@temenosgroup.onmicrosoft.com/resource${data}`;
    window.open(url, '_blank');
  }

   openUrlSolution(id): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.data?.tenantId, RouterSegments.SOLUTION,
      this.data?.solutionId, RouterSegments.VERSIONS]);
    }

    openUrlSolutionVersion(id):void{
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.data?.tenantId, RouterSegments.SOLUTION,
        this.data?.solutionId, RouterSegments.VERSIONS, this.data?.solutionVersionId]);

    }
  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

  openRouteDetails(loggedResponse): any {
    this.instanceService.getInstanceDetailsSftpDetailsByIdByRouteID(this.data.id, loggedResponse.routeId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(loggedData => {
        this.sidenavService.openInRightSidenav(InstanceDetailsAddRouteComponent, { loggedData, edit: true });
      });
  }

/**
 * Filters route data based on a search term entered by the user.
 */
  searchRoute(searchTerm?: string): void {
    this.routeSearchTerm = searchTerm?.trim().toLowerCase() || '';

  if (!this.routeSearchTerm) {
    this.filteredRouteData = [...this.initialRouteData];
  } else {
    this.filteredRouteData = this.initialRouteData.filter(route =>
      route.routeName?.toLowerCase().includes(this.routeSearchTerm) ||
      route.routeId?.toLowerCase().includes(this.routeSearchTerm) ||
      route.direction?.toLowerCase().includes(this.routeSearchTerm) ||
      route.status?.toLowerCase().includes(this.routeSearchTerm)
    );
  }
}

  createRoutes(): any {
    const disabledStatus = [DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.OPERATION_INPROGRESS,
      DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.STARTING,
      DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED];
    if (disabledStatus.find(item=> item === this.data.status) || !this.sftp) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      const data = {
        id: this.data.id,
        sftpEncKeyRotation: this.sftpEncKeyRotation
      };
      this.sidenavService.openInRightSidenav(InstanceDetailsAddRouteComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (!formData) {
          return;
        } else {
          this.routeData = formData;
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.SFTP');
              const message = translate('INSTANCE_DETAILS.CREATE_ROUTE');
              this.toastrService.successMessage(message, title);
            }, 500);
          this.initialLoad();
        }
      });
    }
  }

  editRoute(editData): any {
    const disabledStatus = [DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.OPERATION_INPROGRESS,
      DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.STARTING,
      DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED];
    if (disabledStatus.find(item=> item === this.data.status) || !this.sftp) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      const data = {
        id: this.data.id,
        sftpEncKeyRotation: this.sftpEncKeyRotation,
        edit: true,
        editData
      };
      this.sidenavService.openInRightSidenav(InstanceDetailsAddRouteComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (!formData) {
          return;
        } else {
          this.routeData = formData;
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.SFTP');
              const message = translate('INSTANCE_DETAILS.EDIT_ROUTES');
              this.toastrService.successMessage(message, title);
            }, 500);
          this.initialLoad();
          this.loadRoutesWithKeyExpiration();
        }
      });
    }
  }

  deleteRoute(data): any {
    if(data.status !== 'adding') {
      if(data.status !== 'removed') {
        if(data.status !== 'removing') {
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.TITLE'),
            message: translate('INSTANCE_DETAILS.MESSAGE'),
            confirmButtonText: translate('BUTTONS.DELETE')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
              this.instanceService.deleteInstanceDetailsSftpRoute(this.data.id, data.routeId)
                .pipe(
                  takeUntilDestroyed(this.destroyRef))
                .subscribe((res) => {
                  if (res) {
                    this.routeData = res;
                    setTimeout(() => {
                     const title = translate('TENANT_DETAILS.SFTP');
                     const message = translate('INSTANCE_DETAILS.DELETE_ROUTE');
                      this.toastrService.successMessage(message, title);
                    }, 500);
                    this.initialLoad();
                  }
                },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {
              title:  translate('ERROR_DIALOG.DELETE_SFTP_FAILED'),
              description: errorMessage
            }
          });
        });
            }
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {
              title:  translate('ERROR_DIALOG.DELETE_ROUTE_NOT_AVAILABLE'),
              description: errorMessage
            }
          });
        });
      }
    }
    } else {
      return false;
    }
  }

  getExternalPackages(): void {
    this.solutionsService.getReferencePackagesById(this.data?.solutionId, this.data?.packageReferenceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.externalPackages = data;
      this.externalPackages?.references.forEach(data => data.arrowClick = false);
      this.dataSourceExternalPackages = new MatTableDataSource(this.externalPackages?.references);
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  onExternalPackageArrowClick(data): void {
    this.expandedPackageElement = this.expandedPackageElement === data ? null : data;
    this.externalPackages.references.find(item => item.component === data.component).arrowClick = !this.externalPackages?.references?.find(item => item.component === data.component)?.arrowClick;
    this.externalPackages.references?.forEach(item =>  {
      if(item.component !== data.component) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInnerImages = this.externalPackages?.references?.find(item => item.component === data.component)?.images;
    this.dataSourceInnerPackages = this.externalPackages?.references?.find(item => item.component === data.component)?.packages;
  }

  dateFilter() {
    if (this.selectedActions) {
      this.activityDropdownsList[0]?.options?.map((item) => item.selected = false);
      this.selectedActions.forEach(item => {
        this.activityDropdownsList[0].options.find(option => option.value?.toLowerCase() === item?.toLowerCase()).selected = true;
      })
    } else {
      this.activityDropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: 'InstanceActivity',
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.activityDropdownsList,
      action: this.activityDropdownsList[0].options,
      dateCreated: this.instance?.dateCreated,
      startDate: this.filterStartDate,
      endDate: this.filterEndDate
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns[0].length === 0 && !filteredColumns[1]?.filteredStartDate && !filteredColumns[1]?.filterEndDate) {
          this.selectedActions = [];
          this.activityDropdownsList[0]?.options?.map((item) => item.selected = false);
          this.filterStartDate = undefined;
          this.filterEndDate = undefined;
          this.deploymentLogData = this.logData;
        }
        if (filteredColumns) {
          if (filteredColumns[0]?.length > 0 || filteredColumns[0] !== this.previousSelectedActions) {
            this.previousSelectedActions = filteredColumns[0];
            this.selectedActions = filteredColumns[0];
            if (filteredColumns[0].length > 0) {
              this.deploymentLogData = this.logData?.filter(item => this.selectedActions?.includes(item?.action));
            } else {
              this.deploymentLogData = this.logData;
            }
          }
          if (filteredColumns[1] && filteredColumns[1].filteredStartDate && filteredColumns[1].filteredEndDate) {
            this.filterStartDate = filteredColumns[1].filteredStartDate;
            this.filterEndDate = filteredColumns[1].filteredEndDate;
            this.deploymentLogData = this.deploymentLogData.filter(item => this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
              this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
          }
        }
        this.sortData(this.sortInfo ? this.sortInfo : {active: 'startTime', direction: 'desc'});
      })
  }

  cancelFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    if (this.selectedActions?.length > 0) {
      this.deploymentLogData = this.logData?.filter(item => this.selectedActions?.includes(item?.action));
    } else {
      this.deploymentLogData = this.logData;
    }
    this.sortData(this.sortInfo ? this.sortInfo : {active: 'startTime', direction: 'desc'});
  }

  cancelActionFilter() {
    this.selectedActions = [];
    this.activityDropdownsList[0]?.options?.map((item) => item.selected = false);
    if (this.filterStartDate && this.filterEndDate) {
      this.deploymentLogData = this.logData.filter(item => this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
      this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
    } else {
      this.deploymentLogData = this.logData;
    }
    this.sortData(this.sortInfo ? this.sortInfo : {active: 'startTime', direction: 'desc'});
  }

  onMouseEnter(event) {
    this.currentElement = event.target;
    const inprogressComponents = this.activeComponents.filter(item=> item.status == 'inprogress');
    const completedComponents = this.activeComponents.filter(item=> item.status != 'inprogress');
    const appendData = [...inprogressComponents, ...completedComponents];
    this.componentRef = this.createCallout(appendData);
  }
  @HostListener('mouseover', ['$event'])
  onMouseOver(event) {
    let hoverComponent = event.target;
    let inside = false;
    do {
      if (this.componentRef) {
        if (hoverComponent === this.componentRef.location.nativeElement || hoverComponent === this.currentElement) {
          inside = true;
        }
      }
      hoverComponent = hoverComponent.parentNode;
    } while (hoverComponent);
    if (!inside) {
      this.hideCallout();
    }
  }

  public tabChange(event): void {
    this.selectedTab = event;
    if (event === 1) {
      this.showResultsPagination = true;
      this.loadConfigurations();
    } else {
      this.showResultsPagination = false;
    }
  }

  filterRows(): void {
    // Remove all configuration states
    if (this.filteredConfigurationStates) {
      this.filteredConfigurationStates.splice(0, this.filteredConfigurationStates.length);
    }

    if (this.configurationStates?.length > 0) {
      this.configurationStates.forEach( configState => {
        this.configurations.forEach( config => {
          if(configState.configurationId === config.id){
            if(config?.manifest?.code) {
              configState.codeResult = config.manifest.code;
            }
          }
        });
      });
      this.filteredConfigurationStates = [...this.configurationStates]
      .sort(this.propertyComparator('applicationFinishTime',SortDirection.DESC))
      .filter(configurationState => Constants.CONFIGURATION_FINAL_STATES.includes(configurationState.status));
    }


    if (this.searchTerm != null) {
      const searchBy = this.searchTerm.trim().toLocaleLowerCase();
      this.filteredConfigurationStates = this.filteredConfigurationStates?.filter(configurationState =>
          configurationState.status?.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[configurationState.configurationId].manifest.name.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[configurationState.configurationId].manifest.version.toLocaleLowerCase().includes(searchBy));
    }
    this.paginator.length = this.filteredConfigurationStates?.length;
  }

  /**
   * Opens the selected result in separate tab for viewing
   * @param - the selected configuration state and file name
   */
  viewTestResults(configurationState: ConfigurationState, filename: string, type?: string): void {
    this.crvtService.getViewResultsUrl(configurationState.blueprintId, configurationState.instanceId, configurationState.id, filename, configurationState.tenantId, type)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((viewUrl) => {
      this.urlService.openUrlInNewTab(viewUrl);
    });
  }

  /**
   * Downloads the selected result
   * @param - the selected configuration state and file name
   */
  downloadTestResults(configurationState: ConfigurationState, filename: string): void {
    const type = this.isRvtPack ? 'rvt-results' : undefined;
    const configuration = this.configurationsMap[configurationState.configurationId];
    this.crvtService.downloadCRVT(configuration.blueprintId, configurationState.instanceId, configurationState.id, filename, this.clientName, type)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  /**
   * Calls filter function when search term changes
   * @param - the search term entered
   */
  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
    this.filterRows();
  }

  /**
   * Calls filter function when search term changes for inventoryCloud
   * @param - the search term entered
   */
  searchCloud(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  /**
   * Calls filter function when search term changes for inventoryCloud
   * @param - the search term entered
   */
  searchedItems(result): void {
    this.searchedResult = result;
  }

  /**
   * Sorts the configuration states
   * @param - the column property to sort
   */
  doSort(property: string): void {
    if (!this.sort || this.sort.property !== property) {
      this.sort = {
        property,
        direction: SortDirection.ASC
      };
    } else if (this.sort.direction === SortDirection.ASC) {
      this.sort.direction = SortDirection.DESC;
    } else {
      this.sort = null;
    }

    if (!this.sort) {
      this.filteredConfigurationStates = this.filteredConfigurationStates.sort(this.propertyComparator('applicationFinishTime',
        SortDirection.DESC));
    } else if (this.sort.property === 'duration') {
      this.filteredConfigurationStates = this.filteredConfigurationStates.sort(this.durationComparator(this.sort.direction));
    } else {
      this.filteredConfigurationStates = this.filteredConfigurationStates.sort(this.propertyComparator(this.sort.property,
        this.sort.direction));
    }
    this.applyPaginator();
  }


  /**
   * Calls get available configurations function when apply is clicked for a package
   * @param - the instance of selected cofiguration
   */
  updateInstance(instance: Instance, configStatus): void {
    this.availableConfigurations = this.getAvailableConfigurations(instance);
    this.availableConfigLoaded = true;
    this.isReleasePack = true;
  }

  /**
   * Filters configuration states when filter options changes
   * @param - the option selected in filter
   */
  filterOptionChange(option): void {
    this.selectedFilter = option;
    if (option.value) {
      this.configurationStates = this.allConfigurationStates.filter(item => option.value.includes(item?.status)) || [];
    } else {
      this.configurationStates = this.allConfigurationStates || [];
    }
    this.filterRows();
  }

  /**
   * Redirects to view or download function when configuration name is clicked
   * @param - the selected configuration state
   */
  configurationNameClick(configurationState: any, isRvt?: boolean): void {
    this.dialog.open(ConfigurationDetailsComponent, {
      height: '60vh',
      width: '80vw',
      panelClass: 'flex-dialog',
      data: {
        results: true,
        configurationState,
        configuration: this.configurations.find(item => item.id === configurationState.configurationId),
        isRvt
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
        if (data?.type === 'download') {
          this.downloadTestResults(data?.configuration, data?.resultsReportFile);
        } else if (data?.type === 'view') {
          this.viewTestResults(data?.configuration, data?.resultsReportFile, data?.viewType);
        }
      }
    });
  }

  /* Handles the click event on a Job ID from the activity table */
  jobId(jobId: string) {
  this.showLoader = true;
  this.schedulerService.getScheduleHistoryId(this.data?.tenantId, jobId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: (response) => {
        this.showLoader = false;
        const jobDetails = {
          jobId: response?.id || jobId,
          tenantId: response?.tenantId,
          scheduleId: response?.scheduleId,
          scheduleName: response?.scheduleName,
          scheduleStatus: response?.status
        };
        const element = document.querySelector('.cdk-overlay-container') as HTMLElement;
        if (element) element.style.display = 'block';
        /* Open your ActivityDetailsComponent popup with data */
        const ref = this.dialog.open(ActivityDetailsComponent, {
          height: '60vh',
          width: '50vw',
          panelClass: 'flex-dialog',
          data: jobDetails
        });
        ref.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
          if (element) element.style.display = 'none';
        });
      },
    });
}
  /**
   * Redirects to apply configuration function when configuration name is clicked
   * @param - the selected configuration
   */
  public applyConfigClick(configuration): void {
      if (this.showWarningPopup) {
      this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_BUILD.WARNING_TITLE', {action: translate('INSTANCE_DETAILS.RELEASE_PACKAGE')}),
        message: translate('INSTANCE_DETAILS.UPDATE_BUILD.WARNING_NOTE', {action: translate('INSTANCE_DETAILS.RELEASE_PACKAGE')}),
        confirmButtonText: translate('INSTANCE_DETAILS.UPDATE_BUILD.PROCEED'),
        warning: true
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
          this.applyConfig(configuration);
        }
      })
    } else {
      this.applyConfig(configuration)
    }
  }

  applyConfig(configuration){
    this.configPackage = configuration;
    if (this.instance.dataZone === DataZone.LIVE && !this.configStateVerify &&
      configuration.status !== ConfigurationApplicationStatus.VERIFIED) {
      this.dialog.open(VerifypopupComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog',
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          if (data) {
            const dataVerify = localStorage.getItem('verifyUpdate');
            if(configuration.status === ConfigurationApplicationStatus.VERIFIED) {
              this.configStateVerify = true;
            }
            if (dataVerify === 'true') {
              this.verifyConfiguration(configuration.id, this.instance.id);
            }
            else if(dataVerify === 'false') {
              this.applyConfiguration(configuration.id, this.instance.id, configuration);
            }
          }
      });
    } else {
      this.applyConfiguration(configuration.id, this.instance.id, configuration);
    }
  }

  // Gets solution details based on service id and adds in breadcrumbs
  private loadService(): void {
    const serviceId = this.data?.solutionId;
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId), this.solutionsService.getSolutionVersions(serviceId)])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([service, serviceVersions]) => {
        this.service = service;
        this.serviceVersions = serviceVersions;
        this.loadInstances();
      }, (err) => this.errorPageService.show404Page());
  }

  public getTestResults(id, testType?: String, page?: Number, size?: Number): void {
    this.instanceService.getTestResults(id)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        this.dataLoaded = true;
        this.testResultsTotal = results?.total;
        if (Number(results?.total) > 10) {
        this.instanceService.getTestResults(id, results?.total)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(totalResults => {
          this.sanityEfData(totalResults);
        },
        (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
      } else {
        this.sanityEfData(results);
      }
    },(error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }

  sanityEfData(results): void {
    this.sanityTestResults = results.data?.filter(item =>
      item.testType === TestTypes.SANITY_TEST
    );
    if (this.sanityTestResults?.find(item => item.status === 'inprogress')) {
      this.isSanityTestInprogress = true;
    }
    this.sanityTestResults = this.sanityTestResults?.sort((a, b) => new Date(b.testStartTime).getTime() - new Date(a.testStartTime).getTime());
    this.efTestResults = results.data?.filter(element =>
      element.testType === TestTypes.EF_TEST
    );
    if (this.efTestResults?.find(item => item.status === 'inprogress')) {
      this.isEFTestInprogress = true;
    }
    this.efTestResults = this.efTestResults?.sort((a, b) => new Date(b.testStartTime).getTime() - new Date(a.testStartTime).getTime());
  }

  public excecuteEFTest(): void {
    if (!this.isEFTestInprogress && this.EXCECUTETEST_ENABLE_STATES.includes(this.data?.status)) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('TEST_RESULTS.EF_TEST_TITLE'),
          message: translate('TEST_RESULTS.EF_TEST_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
        if (confirm) {
          this.isEFTestInprogress = true;
          this.instanceService.putEFTest(this.instanceId)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              if (results) {
                this.getTestResults(this.instanceId, TestTypes.EF_TEST);
                this.updateInstnace.emit(this.isEFTestInprogress);
              }
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('ERROR_DIALOG.EF_TEST_FAILED'),
            description: errorMessage
          }
        });
          });
        }
      });
    }
  }

  public excecuteSanityTest(): void {
    if (!this.isSanityTestInprogress && this.EXCECUTETEST_ENABLE_STATES.includes(this.data?.status)) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('TEST_RESULTS.SANITY_TEST_TITLE'),
          message: translate('TEST_RESULTS.SANITY_TEST_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
        if (confirm) {
          this.isSanityTestInprogress = true;
          this.instanceService.putSanityTest(this.instanceId)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              if (results) {
                this.getTestResults(this.instanceId, TestTypes.SANITY_TEST);
                this.updateInstnace.emit(this.isSanityTestInprogress);
              }
          },
          (error) => {
             const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('ERROR_DIALOG.SANITY_TEST_TITLE'),
            description: errorMessage
          }
        });
          });
        }
      });
    }
  }

  public downloadResult(data): void {
    this.crvtService.downloadCRVT(data.blueprintId, data.instanceId, data.id, data.testResultsPath, this.clientName, data.testType)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  public testTabs(event?): void {
    // this.dataLoaded = false;
    if (event === 'efTest') {
      this.sanityTest = false;
      this.efTest = true;
      this.sanityPaginator = false;
      this.EFPaginator = true;
      this.pageIndex = 0;
      this.EFPaginationSize = 10;
      this.dataSourceEFTestResults = new MatTableDataSource(this.efTestResults?.slice(0, 0 + this.EFPaginationSize));
    } else {
      this.efTest = false;
      this.sanityTest = true;
      this.EFPaginator = false;
      this.sanityPaginator = true;
      this.pageIndex = 0;
      this.sanityPaginationSize = 10;
      this.dataSourceSanityTestResults = new MatTableDataSource(this.sanityTestResults?.slice(0, 0 + this.sanityPaginationSize));
    }
  }

  // Gets blueprint details based on blueprint id and sets environment for instance
  private loadBlueprint(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprint => {
        this.blueprint = blueprint.find(item => item.id === blueprintId);
        if (this.instance?.deploymentClass === DeploymentClass.D) {
          this.instance.environment = 'DEV';
        } else {
          if (this.instance?.environment) {
            this.instance.environment = this.blueprint?.pathToLiveConfiguration
            .find(item => item?.instanceId === this.instance?.id)?.environment;
          }
        }
        this.istanceLoaded = true;
        this.loadReleaseData(true);
      }, (err) => this.errorPageService.show404Page());
  }

  // Gets instance details based on instance id and sets build number by matching id with service version
  private loadInstances(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstancesForSolution(this.service.id, undefined, this.data.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        this.instance = instances?.data?.find(item => item.id === instanceId);
        // if (this.instance?.status === DeployStatus.TERMINATING || this.instance?.status === DeployStatus.TERMINATED) {
        //   this.errorPageService.show404Page();
        // }
        this.releaseVersion = this.serviceVersions.find(version => version.id === this.instance?.solutionVersionId)?.releaseVersion;
        if(this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
          this.isAMR = true;
        }
        this.buildNumber = this.serviceVersions.find(version => version.id === this.instance?.solutionVersionId)?.version;
        this.loadBlueprint();
        const now = new Date();
        const currentYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        this.loadUsageSummary(instanceId, currentYearMonth);
        this.metricTimePieMonth = currentYearMonth;
        this.selectedMetricInstance = instanceId;
      }, (err) => this.errorPageService.show404Page());
  }

  // Loads configuration states list according to selected filter
  private loadConfigurations(): void {
    const instance = this.allInstances?.data?.find(item => item.id === this.instance.id);
    this.updateInstance(instance, this.instance?.latestConfigurationState?.status);
    if (this.selectedFilter.value) {
      this.configurationStates = this.allConfigurationStates.filter(item => this.selectedFilter.value.includes(item?.status)) || [];
    } else {
      this.configurationStates = this.allConfigurationStates || [];
    }
    this.configurationsMap = this.configurations?.reduce((acc, configuration) => {
      acc[configuration.id] = configuration;
      return acc;
    }, {});
    this.filterRows();
  }

  // Shows configuration states according to page selection
  private applyPaginator(): void {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    this.pageConfigurationStates = this.filteredConfigurationStates?.slice(startIndex, startIndex + this.paginator.pageSize);
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Sorts configuration states
   * @param - the property and direction to sort
   */
  private propertyComparator(property: string, direction: SortDirection): ComparatorFunc {
    return (configurationState1: ConfigurationState, configurationState2: ConfigurationState): number => {
      if (isDate(configurationState1[property])) {
        return direction === SortDirection.ASC
        ? configurationState1[property]?.getTime() - configurationState2[property]?.getTime()
        : configurationState2[property]?.getTime() - configurationState1[property]?.getTime();
      } else {
        if (configurationState1[property] && configurationState2[property]) {
          return direction === SortDirection.ASC
            ? configurationState1[property].localeCompare(configurationState2[property])
            : -(configurationState1[property].localeCompare(configurationState1[property]));
        }
      }
    };
  }

  /**
   * Sorts configuration states for time related column
   * @param - the direction to sort
   */
  private durationComparator(direction: SortDirection): ComparatorFunc {
    return (configurationState1: ConfigurationState, configurationState2: ConfigurationState): number => {
      if (configurationState1.applicationStartTime && configurationState1.applicationFinishTime
        && configurationState2.applicationStartTime && configurationState2.applicationFinishTime) {
          const duration1 = new Date(configurationState1.applicationFinishTime).getTime()
            - new Date(configurationState1.applicationStartTime).getTime();

          const duration2 = new Date(configurationState2.applicationFinishTime).getTime()
            - new Date(configurationState2.applicationStartTime).getTime();

          return direction === SortDirection.ASC ? duration1 - duration2 : duration2 - duration1;
      }
      return 0;
    };
  }

  /**
   * Populates available configurations according to selected instance
   * @param - the instance selected
   */
  private getAvailableConfigurations(instance: Instance): Configuration[] {
    const requiredEnvironment = this.blueprint?.pathToLiveConfiguration.find(
      ptl => ptl.environment === instance?.environment && ptl.instanceId === instance.id)?.requires;
      let availableConfigurations = this.configurations;
    // Only configurations which are created before (or equal) latest successfully applised configuration on previous environment
    const prodInstance = this.allInstances?.data?.find(instances => instances.id === this.instance.id);
    if (this.instance?.dataZone === DataZone.LIVE &&
      prodInstance?.configurationStates?.find(config => config.status === ConfigurationApplicationStatus.VERIFIED)) {
      const latestVerifiedInstance = prodInstance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.VERIFIED);
      const verifiedInstanceConfig =
        this.getConfigurationById(latestVerifiedInstance.configurationId);
      availableConfigurations = availableConfigurations
        .filter(configuration => configuration.dateCreated === verifiedInstanceConfig.dateCreated);
      } else if((this.releaseManager && (instance?.environment === translate('CONFIGURATIONS.STATE.PREPROD')) && requiredEnvironment)) {
        const requiredInstance = this.allInstances?.data?.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
        if(instance?.environment === translate('CONFIGURATIONS.STATE.PREPROD')) {
          availableConfigurations = [];
          this.configurations.filter((item) => {
            if(instance.latestConfigurationState) {
              const instanceValue = parseInt(instance?.latestConfigurationState?.manifest?.version.split('.').shift());
              const originalValue = parseInt(item.manifest.version.split('.').shift());
              if(instanceValue === originalValue) {
                const patchValue = parseInt(item.manifest.version.split('.').pop(), 10);
                if(patchValue > 0) {
                  availableConfigurations.push(item);
                }
              }
            }
          });
        }
        if (requiredInstance?.configurationStates) {
          const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
            .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
          if (latestSuccessfulStateOfRequiredInstance) {
            const configAvailable = this.configurations;
            const latestAppliedConfigurationOnRequiredInstance =
              this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
              for(const configStates of requiredInstance.configurationStates) {
                if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                  for(const availableConfig of configAvailable) {
                    if(availableConfig.id === configStates.configurationId) {
                      availableConfigurations.push(availableConfig);
                    };
                    availableConfigurations = [...new Set(availableConfigurations)];
                  }
                }
              }
          };
        }
    } else if (requiredEnvironment) {
      const requiredInstance = this.allInstances?.data?.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
      if (requiredInstance?.configurationStates) {
        const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
          .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
        if (latestSuccessfulStateOfRequiredInstance) {
          const configAvailable = availableConfigurations;
          const latestAppliedConfigurationOnRequiredInstance =
            this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
            availableConfigurations = [];
            for(const configStates of requiredInstance.configurationStates) {
              if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                for(const availableConfig of configAvailable) {
                  if(availableConfig.id === configStates.configurationId) {
                    availableConfigurations.push(availableConfig);
                  }
                  availableConfigurations = [...new Set(availableConfigurations)];
                }
              }
            }
          const latestVersion = latestAppliedConfigurationOnRequiredInstance?.manifest?.version;
          if (latestVersion && requiredEnvironment !== InstanceEnvironment.PREPROD) {
    
            const [latestMajor, latestMinor] = latestVersion.split('.').map(num => parseInt(num, 10));
            
            availableConfigurations = this.configurations.filter(item => {
              const [major, minor, patch] = item.manifest.version.split('.').map(num => parseInt(num, 10));
              // version is less than selected major.minor
              const isLowerVersion = major < latestMajor || (major === latestMajor && minor < latestMinor);
              // version belongs to same major.minor (hotfixes)
              const isHotfix = major === latestMajor && minor === latestMinor;
              return isLowerVersion || isHotfix;
            });
          }
          availableConfigurations.sort((a, b) => {
            const asort = a.manifest.version.split('.').map(num => parseInt(num, 10));
            const bsort = b.manifest.version.split('.').map(num => parseInt(num, 10));

            for (let i = 0; i < 3; i++) {
              if (asort[i] > bsort[i]) return 1;
              if (asort[i] < bsort[i]) return -1;
            }
            return 0;
          });
        } else {
          availableConfigurations = [];
        }
      } else {
        availableConfigurations = [];
      }
    }
    if (instance?.configurationStates) {
      const latestAttemptedConfig = instance.configurationStates.map(s => ({ state: s, cfg: this.getConfigurationById(s.configurationId) })).filter(x => !!x.cfg).sort((a, b) => this.compareVersions(b.cfg.version, a.cfg.version));
      const failedStates = [ConfigurationApplicationStatus.CONFIG_FAILED, ConfigurationApplicationStatus.CONFIGURE_FAILED, ConfigurationApplicationStatus.TEST_FAILED, ConfigurationApplicationStatus.FAILED,
          ConfigurationApplicationStatus.VERIFICATION_FAILED, ConfigurationApplicationStatus.VERIFY_CONFIGURED_FAILED];
      const latestSuccess = latestAttemptedConfig.find(x => x.state.status === ConfigurationApplicationStatus.SUCCESS);
            const latestFailed  = latestAttemptedConfig.find(x => failedStates.includes(x.state.status));
        if (latestSuccess) {
          availableConfigurations = availableConfigurations.filter(cfg =>
            this.compareVersions(cfg.version, latestSuccess.cfg.version) > 0
        );
        } else if (latestFailed) {
          availableConfigurations = availableConfigurations.filter(cfg =>
            this.compareVersions(cfg.version, latestFailed.cfg.version) >= 0
        );
      }
    }

    return availableConfigurations;
  }

  compareVersions(version: string, latestVersion: string): number {
    const version1 = version.split('.').map(num => parseInt(num, 10));
    const version2 = latestVersion.split('.').map(num => parseInt(num, 10));
    for (let i = 0; i < Math.max(version1.length, version2.length); i++) {
      if (version1[i] > version2[i]) return 1;
      if (version1[i] < version2[i]) return -1;
    }
    return 0;
  }


  /**
   * Returns configuration corresponding to given configuration id
   * @param - the configuration id
   */
  private getConfigurationById(configurationId: string): Configuration {
    return this.configurations.find(configuration => configuration.id === configurationId);
  }

  /**
  * Opens popup for skipping test user input when apply button clicked
  * @param - the configuration id and instance id
  */
  private applyConfiguration(configurationId: string, instanceId: string, config?): void {
    if (this.allInstances?.data?.find(instance => instance.id === instanceId).deploymentClass !== DeploymentClass.A) {
     this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        width: '566px',
        data: {
          title: translate(`INSTANCE_DETAILS.APPLY_RELEASE_PACKAGE_TITLE`),
          message: translate(`INSTANCE_DETAILS.APPLY_RELEASE_PACKAGE_SELECTION`),
          confirmButtonText: translate('BUTTONS.CONFIRM'),
          confirmationTitle: translate('INSTANCE_DETAILS.APPLY_RELEASE_PACKAGE_CONFIRMATION'),
          optionSelection: [
            {value: 'now', label: 'Now', selected: true},
            {value: 'schedulelater', label: 'Schedule Later', selected: false}
          ]
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          if (confirm.value === 'schedulelater') {
            localStorage.setItem('scheduleInstance', JSON.stringify([{'instanceType': 'Apply Release Package', 'configPackage': this.configPackage, 'instanceName': this.instance?.name, 'blueprintName': this.blueprint?.name}]) );
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.data.tenantId, RouterSegments.SCHEDULE, RouterSegments.CREATE, RouterSegments.TYPE]);
          } else {
            this.dialog.open(SkiptestPopupComponent, {
              minHeight: '342px',
              width: '566px',
              panelClass: 'flex-dialog',
            })
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
              if (data) {
                this.applyConfigInProgress = true;
                data.skipTest = !data.skipTest;
                this.skipTest = data.skipTest;

                this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
              }
            });
          }
        }
      });
    } else {
      this.skipTest = this.allInstances?.data?.find(instance => instance.id === instanceId).deploymentClass === DeploymentClass.A ? true : false;
      this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
    }
  }

  /**
   * Applies selected configuration
   * @param - the configuration id, instance id and skip test value
   */
  private applyConfigurationBasedOnInstance(configurationId, instanceId, skipTest): void {
    this.configService.applyConfiguration(configurationId, instanceId, skipTest)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadReleaseData();
      },
      (error) => {
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
            description: errorMessage,
          }
        });
      });
  }

  /**
   * Verifies selected configuration
   * @param - the configuration id and instance id
   */
  private verifyConfiguration(configurationId: string, instanceId: string): void {
    this.configService.verifyConfiguration(configurationId, instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.isVerifying = true;
        this.loadReleaseData();
      },
      (error) => {
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
            description: errorMessage,
          }
        });
      });
  }

  // Loads all the configurations and configuration states
  private loadReleaseData(initialLoad?): void {
    this.configurationLoaded = false;
    this.isLoadingConfigurations = true;
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
      this.loadDataSubscription = null;
    }
    if (this.isRvtPack && !initialLoad) {
      this.getRvtStates();
    }
    if (this.isReleasePack || initialLoad) {

      const instanceObj: any = {
        blueprintId: blueprintId,
        tenantId: this.data.tenantId,
      };
      this.instanceService.getInstances(instanceObj)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
      this.totalInstance = data;

      this.loadDataSubscription = combineLatest([
        this.loadInstancesWithConfigurationState(blueprintId, this.totalInstance),
        this.configService.getConfigurations(blueprintId)
      ])
        .pipe(takeUntilDestroyed(this.destroyRef))
         .subscribe({
            next: ([instances, configurations]) => {
          const instanceId = this.activatedRoute.snapshot.params.instanceId;
          this.allInstances = instances;
          this.allInstances.data.forEach(instance => {
            if (instance.deploymentClass === DeploymentClass.D) {
              instance.environment = 'DEV';
            } else {
              instance.environment = this.blueprint?.pathToLiveConfiguration.find(item => item?.instanceId === instance?.id)?.environment;
            }
          });
          this.instance = this.allInstances.data.find(instance => instance.id === instanceId);
          this.configurations = configurations;
          this.getMetricsPieChartData();
          if (initialLoad) {
            this.getRvtStates();
            this.loadConfigurations();
          }
          const availableConfigurations: any = this.getAvailableConfigurations(this.instance);
          availableConfigurations.forEach(config => {
            config.status = this.instance?.configurationStates?.find(item => item.configurationId === config.id)?.status;
            config.skipTest = this.instance?.configurationStates?.find(item => item.configurationId === config.id)?.skipTest;
          });
          this.availableConfigurations = availableConfigurations;
          this.isLoadingConfigurations = false;
      },
       error: (error) => {
          this.isLoadingConfigurations = false;
          this.availableConfigurations = [];
          setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        }
      });
    },
    error: (error) => {
      this.isLoadingConfigurations = false;
      this.availableConfigurations = [];
       setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
      });
    } else {
      this.availableConfigurations = [];
      this.isLoadingConfigurations = false;
    }
  }

  private getRvtStates(): void {
    this.instanceService.getTestResults(this.instance.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
      if (Number(response?.total) > 10) {
        this.instanceService.getTestResults(this.instance.id, response?.total)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(result => {
            this.allRvtStates = result.data?.filter(item =>
              item.testType === TestTypes.RVT_TEST
            );
            this.processRvtData();
          })
      } else {
        this.allRvtStates = response.data?.filter(item =>
          item.testType === TestTypes.RVT_TEST
        );
        this.allRvtStates.map(item => item.applicationStart = new Date(item.applicationStartTime));
        this.allRvtStates.map(item => item.applicationFinish = new Date(item.applicationFinishTime));
        this.processRvtData();
      }
    },
    (error) => {
      this.configurationLoaded = true;
      this.processRvtData();
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  processRvtData(): void {
    this.rvtResultsLoaded = true;
    if (this.allRvtStates?.find(config => config.status === ConfigurationApplicationStatus.TESTING)) {
      this.appliedRvtState = this.allRvtStates?.find(config => config.status === ConfigurationApplicationStatus.TESTING);
    }
    if (this.allRvtStates?.find(config => config.id === this.appliedRvtState?.id &&
      config.status === ConfigurationApplicationStatus.SUCCESS)) {
      this.selectedRvtTab = 1;
      this.executeRvtInProgress = false;
      this.loadRvtStates();
    }
    if (this.allRvtStates?.find(config => config.id === this.appliedRvtState?.id &&
      config.status !== ConfigurationApplicationStatus.TESTING && config.status !== ConfigurationApplicationStatus.SUCCESS)) {
      this.executeRvtInProgress = false;
      this.loadRvtStates();
    }
    const configurations = cloneDeep(this.configurations);
    this.configurationsForRvt = configurations?.filter(config => config?.manifest?.test);
    this.configurationsForRvt?.forEach(config => {
      config.status = this.allRvtStates?.find(item => item.configurationId === config.id)?.status;
    });
    this.configurationLoaded = true;
    this.loadRvtStates();
    if (!this.instance || !this.allRvtStates) {
      return;
    }
    this.allRvtStates?.sort((state1, state2) => new Date(state2.applicationStartTime).getTime() - new Date(state1.applicationStartTime).getTime());
    this.instance.rvtStates = this.allRvtStates;
    if (this.instance.rvtStates?.length > 0) {
      this.instance.latestRvtState = this.instance.rvtStates[0];
    }
  }

  private loadRvtStates(): void {
    if (this.selectedRvtFilter.value) {
      this.rvtStates = this.allRvtStates.filter(item => this.selectedRvtFilter.value.includes(item?.status)) || [];
    } else {
      this.rvtStates = this.allRvtStates || [];
    }
    this.pageRvtStates = this.rvtStates;
    this.configurationsMap = this.configurations?.reduce((acc, configuration) => {
      acc[configuration.id] = configuration;
      return acc;
    }, {});
    this.filterRvtRows();
  }

  doRvtSort(property: string): void {
    if (!this.rvtSort || this.rvtSort.property !== property) {
      this.rvtSort = {
        property,
        direction: SortDirection.ASC
      };
    } else if (this.rvtSort.direction === SortDirection.ASC) {
      this.rvtSort.direction = SortDirection.DESC;
    } else {
      this.rvtSort = null;
    }

    if (!this.rvtSort) {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.propertyComparator('applicationFinishTime',
        SortDirection.DESC));
    } else if (this.rvtSort.property === 'duration') {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.durationComparator(this.rvtSort.direction));
    } else {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.propertyComparator(this.rvtSort.property,
        this.rvtSort.direction));
    }
    this.rvtPageChanged();
  }

  filterRvtRows(): void {
    // Remove all configuration states
    if (this.filteredRvtStates) {
      this.filteredRvtStates.splice(0, this.filteredRvtStates.length);
    }

    if (this.rvtStates?.length > 0) {
      this.rvtStates.forEach( configState => {
        this.configurations.forEach( config => {
          if(configState.configurationId === config.id){
            if(config?.manifest?.code) {
              configState.codeResult = config.manifest.code;
            }
          }
        });
      });
      this.filteredRvtStates = [...this.rvtStates]
      .sort(this.propertyComparator('applicationFinishTime',SortDirection.DESC))
      .filter(rvtState => Constants.CONFIGURATION_FINAL_STATES.includes(rvtState.status));
    }

    if (this.rvtSearchTerm != null) {
      const searchBy = this.rvtSearchTerm.trim().toLocaleLowerCase();
      this.filteredRvtStates = this.filteredRvtStates.filter(rvtState =>
          rvtState.status?.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[rvtState.configurationId].manifest.name.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[rvtState.configurationId].manifest.version.toLocaleLowerCase().includes(searchBy)
          );
    }
    this.rvtPageChanged();
  }

  public rvtTabChange(event): void {
    this.selectedRvtTab = event;
    if (event === 1) {
      this.loadRvtStates();
    }
  }

  public executeRvtClick(configuration): void {
    this.executeRvtInProgress = true;
    this.instanceService.executeRVTState(this.instance.id, configuration.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadReleaseData();
      },
      (error) => {
        this.executeRvtInProgress = false;
         const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.RVT_TRANSIENT_FAILED'),
                description: errorMessage
              }
            });
      });
  }

  rvtFilterOptionChange(option): void {
    this.rvtPageIndex = 0;
    this.selectedRvtFilter = option;
    if (option.value) {
      this.rvtStates = this.allRvtStates.filter(item => option.value.includes(item?.status)) || [];
    } else {
      this.rvtStates = this.allRvtStates || [];
    }
    this.filterRvtRows();
  }

  searchRvt(searchTerm?: string): void {
    this.rvtSearchTerm = searchTerm;
    this.filterRvtRows();
  }

  private rvtPageChanged(event?): void {
    if (event?.length) {
      this.rvtPageIndex = event.pageIndex;
      this.rvtPaginatioSize = event.pageSize;
    }
    const startIndex = this.rvtPageIndex * this.rvtPaginatioSize;
    this.pageRvtStates = this.filteredRvtStates?.slice(startIndex, startIndex + this.rvtPaginatioSize) || [];
  }
  /**
   * Loads configuration states for all instances
   * @param - the blueprint id
   */
  private loadInstancesWithConfigurationState(blueprintId: string, instances): Observable<Instance[]> {
    const instanceObj: any = {
      blueprintId: blueprintId,
      tenantId: this.data.tenantId,
      size: instances.total === 0 ? undefined : instances.total
    };
    return this.instanceService.getInstances(instanceObj)
      .pipe(mergeMap((instances: any) => {
        const instanceId = this.activatedRoute.snapshot.params.instanceId;
        this.instanceBlueprint = instances;
        const latestConfigRequests = this.instanceBlueprint.data
          .filter(instance => instance.configurationId)
          .map(instance => this.configService.getConfigurationStates(
            instance.id
          ));
        this.deployedDate = instances.data.length > 0 ? instances.data[instances.data.length - 1].dateUpdated : this.currentDate;
        if (latestConfigRequests.length > 0) {
          return combineLatest(latestConfigRequests).pipe(map((configurationStates: any) => {
            if (configurationStates) {
              this.configResultsLoaded = true;
              configurationStates.forEach(configurationStatesForInstance => {
                if (configurationStatesForInstance?.length > 0) {
                  const instance = instances.data.find(inst => configurationStatesForInstance[0].instanceId === inst.id);
                  this.setInstanceConfigurationStates(instance, configurationStatesForInstance);
                }
              });
            }
            return instances;
          }));
        } else {
          this.configResultsLoaded = true;
        }
        return of(instances);
      }
      ));
  }


  deleteCobDetails(data): any {
    if(this.data?.cob?.status !==  DeployStatus.DELETING) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.COB_DELETE'),
          message: translate('INSTANCE_DETAILS.COB_MESSAGE'),
          confirmButtonText: translate('BUTTONS.DELETE')
        }
      })
        .afterClosed()
        .subscribe({
          next: (confirm) => {
            if (confirm) {
              const cobConfig = {
                id: this.instanceId,
                'operation': 'DELETE'
              }
              this.cobService.putCobConfig(cobConfig)
                .pipe(
                  takeUntilDestroyed(this.destroyRef))
                .subscribe((res) => {
                  if (res) {
                    this.routeData = res;
                    this.initialLoad();
                  }
                },
                (error) => {
                  const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                  this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.DELETE_COB_FAILED'),
                      description: errorMessage}
                    });
                });
            }
          },
          error: (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.DELETE_COB_NOT_AVAILABLE'),
                description: errorMessage
              }
            });
          },
          complete: () => {
            // handle completion if needed
          }
        });
      }
  }

  viewCobDetails(): void {
    this.showLoader = true;
    let cobInstallSpec: any;
    this.cobService.getCobConfigSpec(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((cobSpec: any) => {
      this.showLoader = false;
      cobInstallSpec = this.installationSpecificationService
      .buildDynamicForms(atob(cobSpec?.spec));
      cobInstallSpec.forEach(installationSpecificationForm => {
        this.mapProperties(installationSpecificationForm, this.data?.cob?.inputs);
      });

      const installDocRaw = Object.keys(this.data?.cob?.inputs);
      cobInstallSpec = cobInstallSpec.filter(item => installDocRaw.includes(item.property.name));
      this.dialog.open(CobDetailsComponent, {
        panelClass: 'default-dialog-wrapper',
        autoFocus: false,
        data: {
          dynamicForm: cobInstallSpec,
          instance: this.data
        }
      });
    }, (error) => {
      this.showLoader = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  mapProperties(installationSpecificationForm, selectedVersion): void {
    const keys = Object.keys(selectedVersion);
    keys.forEach(key => {
      if (key === installationSpecificationForm?.property?.name) {
        const properties = installationSpecificationForm.property?.properties;
        if (installationSpecificationForm.property?.type === InstallationSchemaPropertyType.ARRAY) {
          installationSpecificationForm.property.items.enum = selectedVersion[key];
        }
        if(properties) {
          properties.forEach(property =>{
            const selectedItem = Object.keys(selectedVersion[key]);
            selectedItem.forEach(item => {
              if (property?.name === item) {
                property.value = selectedVersion[key][item];
              }
            });
          });
        }
      }
    });
  }

  /**
   * Sets configuration states for all instances
   * @param - instance and its configuration states
   */
  private setInstanceConfigurationStates(instance: Instance, configurationStates: ConfigurationState[]): void {
    if (instance?.id === this.instanceId) {
      this.allConfigurationStates = configurationStates;
    }
    if (configurationStates.find(config => config.status === ConfigurationApplicationStatus.CONFIGURING ||
      config.status === ConfigurationApplicationStatus.VERIFYING)) {
      this.appliedConfigurationState = configurationStates.find(config => config.status === ConfigurationApplicationStatus.CONFIGURING);
    }
    if (configurationStates.find(config => config.id === this.appliedConfigurationState?.id &&
      config.status === ConfigurationApplicationStatus.SUCCESS)) {
      this.selectedTab = 1;
      this.loadConfigurations();
    }
    if (!instance || !configurationStates) {
      return;
    }
    configurationStates.sort((state1, state2) => state2?.applicationStartTime.getTime() - state1?.applicationStartTime.getTime());
    instance.configurationStates = configurationStates;
    if (instance.configurationStates?.length > 0) {
      instance.latestConfigurationState = instance.configurationStates[0];
    }
  }

  // getting configurations states and success states count for showing in metrics pie chart
  getMetricsPieChartData(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    if (this.instance.configurationId) {
      this.configService.getConfigurationStates(instanceId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(configurationStates => {
          this.configurationStateResponse = configurationStates;
          this.modifyConfigState()
      });
    } else {
      this.loadMetricsPieChart();
    }
  }

  modifyConfigState() : void{
    let successStates = [];
    const configurationStates= this.configurationStateResponse?.filter(item => {
      const itemDate = new Date(item?.applicationStartTime);
      return itemDate.getFullYear() === this.metricMonth.getFullYear() && itemDate.getMonth() === this.metricMonth.getMonth();
    });
    configurationStates?.forEach(item => {
      if (item.status === 'success' && !successStates.find(element => element === item.configurationId)) {
        successStates = [...successStates, item.configurationId];
      }
    })
    this.successConfigStates = successStates;
    this.loadMetricsPieChart();
  }

  // forming metrics pie chart parameters
  loadMetricsPieChart(): void {
    this.configurationMonth = this.configurations?.filter(item => {
          const itemDate = new Date(item?.dateCreated);
          return itemDate.getFullYear() === this.metricMonth.getFullYear() && itemDate.getMonth() === this.metricMonth.getMonth();
    });
    const data = [
      { value:  (this.configurationMonth?.length - this.successConfigStates?.length), name: 'Not Deployed' },
      { value:  this.successConfigStates?.length, name: 'Deployed' },
    ]
    const colorCodes = ['#B3DADE', '#008392'];
    this.metricsPiechart = {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c}',
      },
      series: [
        {
          type: 'pie',
          radius: ['80%', '100%'],
          avoidLabelOverlap: false,
          top: 20,
          bottom: 10,
          right: 10,
          left: 10,
          label: {
            show: false,
            position: 'bottom',
            formatter: '',
            fontSize: '20'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0
          },
          color: colorCodes,
          data: data,
        }
      ]
    };
    this.metricsPieChartLoaded = true;
  }

  // Subscribes for notifications for updating the configuration states status accordingly
  private subscribeForNotifications(): void {
    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration' },
      { subject: 'Change Task', data: { status: 'published' } },
      { subject: 'Change Task', data: { status: 'rejected' } },
      { subject: 'Change Task', data: { status: 'applying' } },
      { subject: 'Change Task', data: { status: 'applied' } }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadReleaseData();
        }
      });

    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration.apply' },
      { type: 'com.temenos.saas.engine.configuration.verify' }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        const updatedInsance = this.allInstances?.data?.find(instance => instance.id === notification.data?.instanceId);
        if (updatedInsance) {
          this.loadReleaseData();
        }
      });
  }

  private createCallout(data: any): ComponentRef<CustomTooltipComponent> {
    const viewContainer = this.popupHost.viewContainerRef;
    viewContainer.clear();
    const calloutComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(CustomTooltipComponent);
    const calloutComponentRef = viewContainer.createComponent(calloutComponentFactory);
    calloutComponentRef.instance.data = data;
    return calloutComponentRef;
  }

  hideCallout() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

  getDRStatus(status): void {
    let states = DeployStatus;
    let drStatus = Object.keys(states).find(key => states[key] === status);
    return translate('DISASTER_RECOVERY.DR_STATUS.' + drStatus);
  }

  openMenu(): void {
    this.routeExpandedElement = null;
    this.dataSource?.filteredData?.forEach(data => data.arrowClick = false);
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  onCopy(field): void {
    this.toastrService.clear();
    this.toastrService.checkboxMessage(field + ' Copied')
  }

  openSshKeyForm(routeData): void {
    if (routeData?.status === 'added' || routeData?.status === 'updated') {
      this.routeExpandedElement = null;
      this.dataSource?.filteredData?.forEach(data => data.arrowClick = false);
      setTimeout(() => {
        if (document.getElementsByClassName("cdk-overlay-container")) {
          const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
          if (element) {
            element.style.display = 'block';
          }
        }
      }, 100);
      const instanceId = this.instanceId;
      const data = {
        routeData,
        instanceId
      };
      this.sidenavService.openInRightSidenav(AddSshKeyComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(changed => {
        if (changed) {
          this.showSpinner = true;
          this.isFailed = false;
          this.routeData = [];
          this.loadData(this.routeData);
          this.instanceService.getInstanceDetailsSftpDetailsById(this.data.id, this.direction ? this.direction : undefined, this.status ? this.status : undefined)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            this.showSpinner = false;
            this.isFailed = true;
            this.routeData = data;
            this.loadData(this.routeData);
          },
          (error) => {
            this.showSpinner = false;
            this.isFailed = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          });
        }
      });
    } else {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    }
  }

  viewSshKeys(routeExpandedElement): void {
    const data = {
      routeData: routeExpandedElement,
      viewKeys: true
    };
    this.sidenavService.openInRightSidenav(AddSshKeyComponent, data);
  }

  ngOnDestroy(): void {
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  configureCob(): any {
    this.isCobLoaded = false;
      if(this.installationSpecificationForms) {
      this.configureCobApi();
      }
    }

    configureCobApi(cobStatus?: any): void {
      const reconfigureParams = this.installationSpecificationForms;
      this.isCobLoaded = true;
      const cobData = {
        instanceName : this.data?.name,
        cobStatus : cobStatus,
        dynamicFormModel: this.installationSpecificationForms[0]
      };
    this.sidenavService.openInRightSidenav(DynamicFormComponent, cobData)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(dynamicFormModel => {
          if(dynamicFormModel) {
            const installationDocument = {};
            let operation;
            if(cobStatus === 'reconfigure') {
              operation = 'RECONFIGURE';
            } else if(cobStatus === 'update') {
              operation = 'UPDATE';
            } else {
              operation = 'CREATE';
            }
            this.installationSpecificationForms = reconfigureParams;
            this.installationSpecificationForms?.forEach(installationSpecificationForm => {
              const installationSpecificationFormValue = this.installationSpecificationService.getFormValue(
                installationSpecificationForm);
                if(cobStatus) {
                  installationSpecificationFormValue.cobParameters.PipelineID = this.data?.cob?.adoPipelineUrl ? this.data?.cob?.adoPipelineUrl.split('=').pop() : ''
                } else {
                  installationSpecificationFormValue.cobParameters.PipelineID = ''
                }
              Object.assign(installationDocument, installationSpecificationFormValue);
            });
            const data = {
              id: this.instanceId,
              inputs: installationDocument,
              operation: operation
            }
            this.cobService.putCobConfig(data)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result: any) => {
              if(result) {
                this.cobResultsTable();
              }
            },(error)=>{
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
                data: {
                  title: translate('ERROR_DIALOG.UPDATE_COB_FAILED'),
                  description: errorMessage}
              });
            });
          }
        });
      }

  cobResultsTable(): void {
    this.instanceService.getInstanceById(this.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instance: any) => {
        if(instance) {
          this.data = instance;
          if(this.data?.cob && this.data?.cob?.inputs) {
            const propertyKey = Object.keys(this.data?.cob?.inputs);
            const title = propertyKey[0];
            if(this.data?.cob?.inputs[title]) {
              this.sch1 = cronstrue.toString(this.data?.cob?.inputs[title]?.Schedule1);
              this.sch2 = cronstrue.toString(this.data?.cob?.inputs[title]?.Schedule2);
            }
          }
        }
      });
      this.cobService.getCobConfigSpec(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((cobSpec: any) => {
        this.installationSpecificationForms = this.installationSpecificationService.buildDynamicForms(atob(cobSpec?.spec));
      });
    this.cobService.getCobConfigResults(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((cobResults: any) => {
      if (Number(cobResults?.total) > 10) {
        const size = cobResults?.total;
        this.cobService.getCobConfigResults(this.instanceId, size)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((cobResults: any) => {
          this.cobResults = cobResults.data;
          this.cobResultsExtended();
        });
      } else {
        this.cobResults = cobResults.data;
        this.cobResultsExtended();
      }
    },(error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }

  cobResultsExtended(): void {
      this.cobResults.forEach(item => {
        item.cobDate = item.cobDate.substr(0, 4) + "-" + item.cobDate.substr(4, 2) + "-" + item.cobDate.substr(6, 2);
        }
      )
      if(this.cobResults?.length > 0) {
        this.cobResults?.forEach(element => {
          element.updatedStages = [];
          let obj;
          element.stages =element?.stages.filter(item => item.stage !== 'COB-REPORT');
          element?.stages.forEach(innerElement => {
            if(element?.updatedStages?.find(item => (item.stage === innerElement.stage) && (innerElement.status.toLowerCase() !== 'started'))) {
              element.updatedStages.find(item => (item.stage === innerElement.stage)).endTime = innerElement.time.trim();
              element.updatedStages.find(item => (item.stage === innerElement.stage)).status = innerElement.status.toLowerCase();
              element.updatedStages.find(item => (item.stage === innerElement.stage)).message = innerElement.message;
            } else {
            obj = innerElement;
            obj.startTime = innerElement.time.trim();
            obj.status = innerElement.status.toLowerCase();
            element.updatedStages = [...element.updatedStages, obj];
            }
          })
          element.updatedStages.forEach(item => {
            item.duration = this.durationPipe.transform(item.startTime, item.endTime, undefined);
            item.milliseconds = new Date(item.endTime).getTime()
            - new Date(item.startTime).getTime();
          })
          element.totalMilliSeconds = [];
          element.updatedStages.forEach(item => {
            if(item.milliseconds) {
              element.totalMilliSeconds = Number(element.totalMilliSeconds) + Number(item.milliseconds);
            }
          });
          element.updatedStages.forEach(item => {
            element.totalTime = this.convertMiliseconds(element.totalMilliSeconds);
          });
          if(element.completionMode === 'manual') {
            element.status = 'failed'
          } else {
            element.updatedStages.find(item => (item.status.toLowerCase() === 'failed')) ? element.status = 'failed' : (element.updatedStages.find(item => (item.status.toLowerCase() === 'started'))) ? element.status = 'started' : ((element.updatedStages.find(item => (item.status.toLowerCase() === 'not started'))) ? element.status = 'not started' : (element.updatedStages.find(item => (item.stage === 'POST-COB'))) ? element.status = 'completed' : element.status = 'started');
          }
        });
      }
    this.cobTable = this.cobResults;
    this.cobTable = this.cobTable?.sort((a, b) => new Date(b.cobDate).getTime() - new Date(a.cobDate).getTime());
    this.pageIndex = 0;
    this.cobPaginationSize = 10;
    this.dataSourceCob = new MatTableDataSource(this.cobTable?.slice(0, 0 + this.cobPaginationSize));
  }

  downloadCobReport(data): void {
    const pack = 'cob-results'
    if(data.reportFile.split('/').length > 1) {
      data.reportFile = data.reportFile.split('/')[2];
    } else {
      data.reportFile = data.reportFile;
    }
    this.crvtService.downloadCRVT(this.data.blueprintId, this.instanceId, data.cobRunId, data.reportFile, this.clientName,pack)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  checkRadioButton(option): void {
    this.dbFilter.find(item => item.name === option.name).selected = !this.dbFilter.find(item => item.name === option.name).selected;
  }

  applyFilter(data): void {
    this.dbFilter = data;
    const selectedFilters = this.dbFilter.filter(item => item.selected === true).map(item => item.value);
    selectedFilters.forEach(filter => {
      this.dbFilterRecord.find(item => item.value === filter).selected = true;
    })
    let filteredResults = [];
    if (selectedFilters?.length > 0) {
      const isStatus = this.dbStatusFilter.filter(item => item.selected === true);
      const isType = this.dbTypeFilter.filter(item => item.selected === true);
      const isName = this.dbNameFilter.filter(item => item.selected === true);

     const filteredStatusResults = this.backupResults.filter(item => (selectedFilters.includes(item.status)) || (selectedFilters.includes('expired') && item.isExpired));
     const filteredTypeResults = this.backupResults.filter(item => (selectedFilters.includes(item.backupType)));
     const filteredNameResults = this.backupResults.filter(item => (selectedFilters.includes(item?.backupInterval)));
     if(isStatus?.length > 0 && isType?.length > 0 && isName?.length > 0){
     if(filteredStatusResults?.length > 0 && filteredTypeResults?.length > 0 && filteredNameResults?.length > 0){
        filteredResults = this.backupResults.filter(item =>
        {
          (((selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) && selectedFilters.includes(item?.backupType)) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
        }
        );
      }
    }
    if(isStatus?.length > 0 && isType?.length > 0 && isName?.length > 0){
      if(filteredStatusResults?.length > 0 && filteredTypeResults?.length > 0 && filteredNameResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           (selectedFilters.includes(item?.backupType) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
         );
         filteredResults = filteredResults.filter(item =>
          (selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) || selectedFilters.includes('')
        );
       }
     }
     else if(isStatus?.length > 0 && isName?.length > 0){
      if(filteredStatusResults?.length > 0 && filteredNameResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           ((selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
         );
       }
     }
     else if(isType?.length > 0 && isName?.length > 0){
      if(filteredTypeResults?.length > 0 && filteredNameResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           (selectedFilters.includes(item?.backupType) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
         );
       }
     }
     else if(isType?.length > 0 && isStatus?.length > 0){
      if(filteredTypeResults?.length > 0 && filteredStatusResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           (selectedFilters.includes(item?.backupType) && (selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired))) || selectedFilters.includes('')
         );
       }
     }
     else{
      filteredResults = this.backupResults.filter(item => ((selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) || selectedFilters.includes(item?.backupType) || selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes(''));
     }
    } else {
      filteredResults = this.backupResults;
    }
    this.dbStatus = selectedFilters;
    this.dbFilterTags = [];
    selectedFilters.forEach(item => {
      this.dbFilterTags = [...this.dbFilterTags, this.dbFilterRecord.find(filter => filter.value === item)?.name];
    })
    if(selectedFilters[0] === ''){
      this.dbStatus = [this.dbStatusFilter[0].name];
    }
    if (this.searchText) {
      filteredResults = filteredResults.filter(item => item.to?.databaseName?.toLowerCase().includes(this.searchText) || item.to?.fileName?.toLowerCase().includes(this.searchText) || item.to?.serverName?.toLowerCase().includes(this.searchText) ||
      item.component?.toLowerCase().includes(this.searchText) || item.ticketNumber?.toLowerCase().includes(this.searchText));
    }
    this.pageIndex = 0;
    const tableData = filteredResults?.slice(0, 0 + this.dbPaginationSize);
    this.backupTable = filteredResults;
    this.dataSourceDb = new MatTableDataSource(tableData);
    this.menuClose();
  }

  menuClose(): void {
    this.dbFilter.forEach(item => item.selected = false)
    const selectedFilters = this.dbFilterRecord.filter(item => item.selected === true).map(item => item.value);
    selectedFilters.forEach(filter => {
      this.dbFilter.find(item => item.value === filter).selected = true;
    })
  }

  searchBp(event): void {
    this.searchText = event.target.value;
    let filteredResults = this.backupResults.filter(item => item.to?.databaseName?.toLowerCase().includes(event.target.value.toLowerCase()) || item.to?.fileName?.toLowerCase().includes(event.target.value.toLowerCase()) || item.to?.serverName?.toLowerCase().includes(event.target.value.toLowerCase()) ||
    item.component?.toLowerCase().includes(event.target.value.toLowerCase()) || item.ticketNumber?.toLowerCase().includes(event.target.value.toLowerCase()));
    const selectedFilters = this.dbFilter.filter(item => item.selected === true).map(item => item.value);
    if (selectedFilters.length > 0) {
      filteredResults = filteredResults.filter(item => selectedFilters.includes(item.status) || selectedFilters.includes(''));
    }
    this.pageIndex = 0;
    const tableData = filteredResults?.slice(0, 0 + this.dbPaginationSize);
    this.backupTable = filteredResults;
    this.dataSourceDb = new MatTableDataSource(tableData);
  }

  getDatabases(): void  {
    this.instanceService.getInstanceDatabases(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.databases = response.databases;
        this.getInstanceBackupResults();
      },
      (error) => {
        this.getInstanceBackupResults();
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }
  convertMiliseconds(miliseconds: number) {
    let days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

    total_seconds = Math.floor(miliseconds / 1000);
    total_minutes = Math.floor(total_seconds / 60);
    total_hours = Math.floor(total_minutes / 60);
    days = Math.floor(total_hours / 24);

    seconds = total_seconds % 60;
    minutes = total_minutes % 60;
    hours = total_hours % 24;

    hours = (hours < 10) ? '0' + hours : hours;
    minutes = (minutes < 10) ? '0' + minutes : minutes;
    seconds = (seconds < 10) ? '0' + seconds : seconds;

    return days > 0 ? (days + "days " + hours + ":" + minutes + ":" + seconds) : (hours + ":" + minutes + ":" + seconds);
  };

  onCobArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.dataSourceCob.filteredData.find(item => item.cobRunId === data.cobRunId).arrowClick = !this.dataSourceCob?.filteredData.find(item => item.cobRunId === data.cobRunId).arrowClick;
    this.dataSourceCob?.filteredData.forEach(item =>  {
      if(item.cobRunId !== data.cobRunId) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInnerCob = this.dataSourceCob?.filteredData.find(item => item.cobRunId === data.cobRunId).updatedStages;
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        element.style.display = 'none';
      }
    }, 200);
  }

  onEditClick(data, cobStatus): void {
    this.menuItemClick();
    this.getPreviousVersionData(data);
    if(this.installationSpecificationForms) {
      this.configureCobApi(cobStatus);
    }
  }

  private getPreviousVersionData(installDocRaw): void {
    this.cobService.getCobConfigSpec(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((cobSpec: any) => {
        this.installationSpecificationForms = this.installationSpecificationService.buildDynamicForms(atob(cobSpec?.spec));
      });
    Object.keys(installDocRaw).forEach(key => {
      const propertyKey = Object.keys(installDocRaw[key]);
      const propertyValue = Object.assign(installDocRaw[key]);
      propertyKey.forEach(controlName => {
        this.installationSpecificationForms?.forEach(nestedForm => {
          nestedForm?.formGroup?.controls[key]?.get(controlName)?.setValue(
            propertyValue[controlName].length === undefined ? '' : propertyValue[controlName]);
          nestedForm?.property?.properties?.forEach(element => {
            if (nestedForm?.formGroup?.controls[key]?.get(element.name)) {
              element.updatedValue = nestedForm.formGroup.controls[key].get(element.name).value;
            }
          });
        });
      });
    });
  }

  messageClick(msg): void {
    this.sweetAlertService.alertWithMessage(msg);
  }

  getInstanceBackupResults(): void {
    this.isBackupTableLoaded = false;
    this.dbBackupService.getInstanceDbBackups(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        if (Number(results.total) > 10) {
          this.dbBackupService.getInstanceDbBackups(this.instanceId, results?.total)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.processDbData(response);
            })
        } else {
          this.processDbData(results);
        }
      },
      (error) => {
        this.isBackupTableLoaded = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  processDbData(results): void {
    let sortedData;
    results.data = results?.data?.sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime());
    sortedData = results?.data;
    sortedData?.forEach(item => {
      let createdAt = new Date(item.createdAt);
      let expirationDate = new Date(item.expirationDate);
      let days = Math.floor((Date.UTC(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()) - Date.UTC(createdAt.getFullYear(), createdAt.getMonth(), createdAt.getDate()) ) /(1000 * 60 * 60 * 24));
      item.expiryDays = days;
      if (item.status === 'completed' && (new Date(item?.expirationDate).setHours(12, 0, 0, 0) - new Date().setHours(12, 0, 0, 0) < 0)) {
        item.isExpired = true;
      }
      item.typeTag = item.from?.type?.toLowerCase()?.includes('postgresql') ? 'PostgreSQL' : item.from?.type?.toLowerCase()?.includes('sql') ? 'MSSQL' : '';
    })
    this.dbInprogess = sortedData?.find(item => item.status === 'inprogress');
    this.backupResults = sortedData;
    this.backupTable = sortedData;
    this.isBackupTableLoaded = true;
    this.dbFilter = this.dbStatusFilter.concat(this.dbTypeFilter, this.dbNameFilter);
    this.dbFilterRecord = cloneDeep(this.dbFilter);
  }

  openDetails(element): void {
    if(element?.to?.serverName || element?.to?.fileName || element?.to?.databaseName){
    element.from.releaseVersion = element.to.releaseVersion = element?.configurationVersion;
    element.from.solutionVersion = element.to.solutionVersion = element?.solutionReleaseVersion;
    this.dialog.open(DbBackupDetailsComponent, {
      maxHeight: '99vh',
      width: '678px',
      panelClass: 'flex-dialog',
      data: element
    });
    }else{
        this.dialog.open(ErrorDialogComponent, {
        minHeight: '226px',
        width: '566px',
        panelClass: 'flex-dialog',
        data: {
          internalError: true,
          description: translate('INSTANCE_DETAILS.DATABASE_BACKUP_DETAILS_NOT_FOUND'),
        }
      });
    }
 
  }

  createNewBackup(): void {
    if (this.databases?.length === 0) {
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '226px',
        width: '566px',
        panelClass: 'flex-dialog',
        data: {
          internalError: true,
          description: translate('INSTANCE_DETAILS.DATABASE_DETAILS_NOT_FOUND'),
          note: translate('INSTANCE_DETAILS.DATABASE_DETAILS_NOT_FOUND_NOTE_MSG'),
        }
      });
      return;
    }

    const data = {
      id: this.instanceId,
      subtitle: this.data?.name,
      databases: this.databases,
      instance: this.data,
      dbResults: this.backupResults
    };
    this.sidenavService.openInRightSidenav(DbBackupFormComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      if (result) {
        this.getInstanceBackupResults();
      }
    })
  }

  menuItemClick(): void {
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  menuClick(cobData): void {
    const data = {
      id: this.instanceId,
      cobId: cobData.cobRunId,
      completionMode: "manual"
    }
    this.cobService.putCobConfigbyId(data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
      if(result) {
        this.cobResultsTable();
      }
    },(error)=>{
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.UPDATE_COB_FAILED'),
          description: errorMessage}
        });
    });
  }

  onClickLink(cobId): void {
    let url;
    url = `${this.adoPipelineUrl}/${this.adoProjectName}/_build/results?buildId=${cobId}`;
    window.open(url, '_blank');
  }

  ticketNumberClick(ticketNumber): void {
    const url = `https://itsm-servicedesk.temenos.com/browse/${ticketNumber}`;
    window.open(url, '_blank');
  }

  openDeleteForm(dbForm): void {
    const data = {
      databases: dbForm,
      instanceName : this.data?.name
    };
    this.sidenavService.openInRightSidenav(DatabaseBackupComponent, data).
    pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
        if(data){
          this.getInstanceBackupResults();
        }
        });
  }

  extendBackup(dbForm): void {
    const data = {
      form: dbForm,
      instanceName : this.data?.name,
      id: this.instanceId,
      subtitle: this.data?.name,
      instance: this.data,
      databases: this.databases,
      dbResults: this.backupResults,
      isExtendBackup: true
    };
    this.sidenavService.openInRightSidenav(DbBackupFormComponent, data).
    pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
        if(data){
          this.getInstanceBackupResults();
        }
      });
  }


private showErrorDetails(data): void {
      if (data?.errors?.length) {
       const dialogRef = this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('INSTANCE_DETAILS.DATABASE_BACKUP.DB_BACKUP_FAILED'),
            descriptionError: data?.errors,
            subtitle: this.data?.name
          }
         });
        }
}

  getEncKeys(): void {
    this.instanceService.getEncryptionKeys(this.data.id).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
      if (result && result.length > 0) {
        result.forEach(element => {
          element.publicKey = atob(element.publicKey);
        });
        const filteredRecords = this.filterHighestVersionRecords(result);
        this.initialEncKeys = filteredRecords;
        this.encKeys = filteredRecords;
        this.initialEncKeyFilterItems();
      }
      this.encKeyLoader = false;
    }, (error) => {
      this.encKeyLoader = false;
      this.initialEncKeyFilterItems();
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  /**
   * Filters encKey data based on a version for same key name.
   */
  filterHighestVersionRecords(records: any[]) {
    if(records.length > 0){
    const maxVersions = records.reduce((acc, record) => {
      const name = record.name;
      const version = Number(record.version);
      if (!acc[name] || version > acc[name]) {
        acc[name] = version;
      }
      return acc;
    }, {});
    return records.filter(record => {
      const version = Number(record.version);
      const maxVersionForName = maxVersions[record.name];
      return version === maxVersionForName;
    });
  }
  }

 /**
 * Filters encKey data based on a search term entered by the user.
 */
searchEncKey(searchTerm?: string): void {
  this.searchTerm = searchTerm;
}

/**
 * Method to be called to apply the initial filter from localstorage
 */
initialEncKeyFilterItems() {
  this.encKeys = this.initialEncKeys;
      if (this.expiryDateDropdownsList[0].options[0].selected && this.encFilterStartDate && this.encFilterEndDate) {
        this.encKeys = this.encKeys?.filter(item => this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') >= this.datePipe.transform(this.encFilterStartDate, 'yyyy-MM-dd') &&
          this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') <= this.datePipe.transform(this.encFilterEndDate, 'yyyy-MM-dd'));
      }
}

  createEncKey() {
    if (this.keyDisabledStatus.find(item=> item === this.data.status) || this.INSTANCE_DEPLOYING_STATES.includes(this.data?.status) || !this.sftp) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    } else {
      const data = {
        id: this.data.id
      };
      this.sidenavService.openInRightSidenav(AddEncKeyComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (!data) {
          return;
        } else {
          this.getEncKeys();
        }
      });
    }
  }

  keyFilterColumns(): void {
    if(this.date) {
      this.expiryDateDropdownsList[0].options.filter((item) => {
        if (item.value === this.date) {
          item.selected = true;
        }
      });
    }
    const data = {
      name: translate('SCHEDULES.SCHEDULE_FILTERS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.expiryDateDropdownsList,
      scheduleDate: this.expiryDateDropdownsList[0].options,
      scheduleStartDate: this.expiryDateDropdownsList[0].options[0]?.selected ? moment(this.encFilterStartDate) : '',
      scheduleEndDate: this.expiryDateDropdownsList[0].options[0]?.selected ? moment(this.encFilterEndDate) : '',
      scheduleColumns: [
        'date'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        if(filteredColumns[2] !== '') {
          localStorage.removeItem('filteredEncKeyDate');
          this.date = filteredColumns[2];
          localStorage.setItem('filteredEncKeyDate', JSON.stringify(filteredColumns[2]));
        }
        if (filteredColumns[2]?.length === 0){
          this.resetScheduleFilter();
        } else {
          this.filterScheduleItems(filteredColumns);
        }
      }
    });
  }

  filterScheduleItems(filteredColumns): void {
    if (filteredColumns) {
      this.encKeys = this.initialEncKeys;

      if (this.expiryDateDropdownsList[0].options[0].selected && moment(filteredColumns[3].filteredStartDate).isValid() && moment(filteredColumns[3].filteredEndDate).isValid()) {
        this.encFilterStartDate = filteredColumns[3].filteredStartDate;
        this.encFilterEndDate = filteredColumns[3].filteredEndDate;
        localStorage.setItem('filteredEncKeyStartDate', this.encFilterStartDate);
        localStorage.setItem('filteredEncKeyEndDate', this.encFilterEndDate);
        this.encKeys = this.encKeys?.filter(item => this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') >= this.datePipe.transform(this.encFilterStartDate, 'yyyy-MM-dd') &&
          this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') <= this.datePipe.transform(this.encFilterEndDate, 'yyyy-MM-dd'));
      } else {
        this.encFilterStartDate = undefined;
        this.encFilterEndDate = undefined;
        localStorage.removeItem('filteredEncKeyStartDate');
        localStorage.removeItem('filteredEncKeyEndDate');
      }
    }
  }

  cancelScheduleDateFilter() {
    this.encFilterStartDate = undefined;
    this.encFilterEndDate = undefined;
    this.expiryDateDropdownsList[0].options[0].selected = false;
    this.date?.forEach(element => {
      if(element.includes(this.expiryDateDropdownsList[0].options[0].value)) {
        this.date.pop(element);
      }
    });
    localStorage.removeItem('filteredEncKeyStartDate');
    localStorage.removeItem('filteredEncKeyEndDate');
    localStorage.removeItem('filteredEncKeyDate');
    this.filterScheduleItems(this.filteredColumns);
  }

  resetScheduleFilter(): void {
    this.expiryDateDropdownsList[0].options.filter((item) => {item.selected = false});
    this.date = undefined;
    this.encFilterStartDate = undefined;
    this.encFilterEndDate = undefined;
    this.encKeys = this.initialEncKeys;
    localStorage.removeItem('filteredEncKeyDate');
    localStorage.removeItem('filteredEncKeyStartDate');
    localStorage.removeItem('filteredEncKeyEndDate');
  }

  public inventoryTabs(event?): void {
    this.components =false;
    this.kubernetes =false;
    this.cloud = false;
    this.products = false;
    if (event === 'cloud') {
      this.cloud = true;
      this.cloudPaginator = true;
      this.pageIndex = 0;
      this.CloudPaginationSize = 10;
    }else if(event === 'components'){
      this.components =true;
    }else if(event === 'kubernetes'){
      this.kubernetes =true;
    }else if(event === 'products'){
      this.products =true;
    }
    this.inventoryDetailsCloud();
  }

  getType(type): void {
    return this.typeOptions.find(item=> item.value === type).label;
  }

  getProductVersions(version): void {
    return this.prodVersionOptions.find(item=> item.value === version).label;
  }

  getProductIsManaged(isMaanaged):void {
    return this.prodIsManagedOptions.find(item=> item.value === isMaanaged).label;
  }

  cancelTypeFilter(data) {
    let selectedItem = this.selectedType.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('inventoryCloudFiltered');
      this.selectedType.splice(selectedItem, 1);
      this.InventoryCloudDropdownList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('inventoryCloudFiltered', JSON.stringify(this.selectedType));
      this.filterInventoryItems(this.filteredColumns);
    }
  }

  cancelVersionFilter(data){
    let selectedItem = this.selectedVersion.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('prodVersionsFiltered');
      this.selectedVersion.splice(selectedItem, 1);
      this.inventoryProdDropdown[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('prodVersionsFiltered', JSON.stringify(this.selectedVersion));
      this.filterProductItems(this.filteredProdColumns);
    }
    if (this.selectedVersion.length === 0 && this.selectedIsManaged.length === 0) {
          this.inventoryProductsData = this.inventoryProducts;
        }
  }

  cancelIsManagedFilter(data){
    let selectedItem = this.selectedIsManaged.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('prodIsManagedFiltered');
      this.selectedIsManaged.splice(selectedItem, 1);
      this.inventoryProdDropdown[1].options.find(item => item.value === data).selected = false;
      localStorage.setItem('prodIsManagedFiltered', JSON.stringify(this.selectedIsManaged));
      this.filterProductItems(this.filteredProdColumns);
    }
    if (this.selectedVersion.length === 0 && this.selectedIsManaged.length === 0) {
          this.inventoryProductsData = this.inventoryProducts;
        }
  }

  resetProductFilter(){
    this.selectedVersion = [];
    this.selectedIsManaged =[];
    this.sidenavService.searchFilter.next('data');
    this.inventoryProdDropdown[0].options.filter((item) => {item.selected = false});
    this.inventoryProdDropdown[1].options.filter((item) => {item.selected = false});
    this.productVersions = undefined;
    this.prodIsManaged = undefined;
    this.inventoryProductsData = this.inventoryProducts;
    localStorage.removeItem('prodVersionsFiltered');
    localStorage.removeItem('prodIsManagedFiltered');
  }

  syncInventoryCloud(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INVENTORY.SYNC'),
        message: translate('INVENTORY.SYNC_MESSAGE'),
        note: 'Note: This action will send a request to refresh the inventory data from the Cloud.The process typically completes within <b>2 to 3 minutes</b>. Please <b>refresh</b> the page <b>after 3 minutes</b> to see the updated data.',
        confirmButtonText: translate('DIALOG.CONFIRM')
      }
    })
      .afterClosed()
      .subscribe({
        next: (confirm) => {
          if (confirm) {
            this.inventoryService.putInventoryByInstance(this.instanceId).pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
              this.inventoryDetailsCloud();
            },
            (error) => {
              this.showSpinner = false;
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('ERROR_DIALOG.SYNC_INVENTORY_FAILED'),
                  description: errorMessage
                }
              });
            })
          }
        }
      })
  }
searchInventory(searchTerm?: string): void {
  this.searchInventoryTerm = searchTerm;
}
searchedComponentItems(result): void {
  this.searchedComponentResult = result;
}
filterInventoryComponent() {
  if (this.componentStatus) {
    this.ComponentFilter[0].options.filter((item) => {
      if (item.value === this.status) {item.selected = true;}
    });
  } else {
    this.ComponentFilter[0].options.filter((item) => {item.selected = false;});
  }
  const data: any = {
    name: translate('TENANT_DETAILS.COMPONENTS'),
    title: translate('INSTANCE_STATUS.FILTER_TITLE'),
    subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
    isMultiSelect: false,
    filteredColumns: this.ComponentFilter,
    componentStatus: this.componentFilterOptions,
    componentColumn:['status']
  };
  this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
  .pipe(takeUntilDestroyed(this.destroyRef))
  .subscribe((filteredColumns) => {
    if (filteredColumns) {
      this.clearData = true;
      if (filteredColumns[0] !== '') {this.componentStatus = filteredColumns[0];}
      this.filterComponentItems(filteredColumns);
    }
  });
}
filterComponentItems(filteredColumns): void {
  this.inventoryComponents = this.inventoryComponentData;
  if (filteredColumns) {
    this.selectedStatus = [];
    if (filteredColumns[0]?.length > 0) {
      this.selectedStatus = filteredColumns[0];
      localStorage.setItem('filteredComponentStatus',JSON.stringify(this.selectedStatus));
      this.inventoryComponents = this.inventoryComponents?.filter((item) =>this.selectedStatus?.includes(item?.status));
    } else {
      localStorage.removeItem('filteredComponentStatus');
    }
  }
}

getStatusLabel(status): void {
  return this.componentFilterOptions.find((item) => item.value === status).label;
}

cancelComponentFilter(data) {
  let selectedItem = this.selectedStatus.indexOf(data);
  if (selectedItem > -1) {
    localStorage.removeItem('filteredComponentStatus');
    this.selectedStatus.splice(selectedItem, 1);
    this.ComponentFilter[0].options.find((item) => item.value === data).selected = false;
    localStorage.setItem('filteredComponentStatus',JSON.stringify(this.selectedStatus));
    this.filterComponentItems(this.filteredColumns);
  }
  if (this.selectedStatus.length === 0) {
    this.inventoryComponents = this.inventoryComponentData;
  }
}

resetComponentFilter(): void {
  this.selectedStatus = [];
  this.sidenavService.searchFilter.next('data');
  this.ComponentFilter[0].options.filter((item) => {
    item.selected = false;
  });
  this.componentStatus = undefined;
  this.inventoryComponents = this.inventoryComponentData;
  localStorage.removeItem('filteredComponentStatus');
}

  /**
   * This method calls when a user need to edit the enc keys.
   * @param value would be the selected key data.
   */
  editKeyRoute(value): void {
    const data = {
      id: this.instanceId,
      edit: true,
      value
    };
    this.sidenavService.openInRightSidenav(AddEncKeyComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data) => {
      if (!data) {
        return;
      } else {
        this.getEncKeys();
      }
    });
  }

  searchKubernetes(searchTerm?: string): void {
    this.searchKubTerm = searchTerm;
  }
  searchedKubernetesItems(result): void {
    this.searchedKubernetesRes = result;
  }

  searchProducts(searchTerm?: string): void {
    this.searchProductTerm = searchTerm;
  }
  searchedProductItems(result): void {
    this.searchedProductsRes = result;
  }

  /**
   * This method calls when a user needs to view the resource by type .
   */
  viewInventoryCloud(){
    const dataInventory = {
        inventoryData: this.initialCloudResourceData,
        instanceName: this.instance?.name
      };
       this.sidenavService.openInRightSidenav(CloudResourcesInventoryComponent, dataInventory);
  }

  viewKubernetesDetails(value): void {
    this.dialog.open(InventoryKubernetesComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '1280px',
      autoFocus: false,
      data: {
        title: value.name,
        message: 'Name Space',
        records: value
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if (response) {
        }
      })
  }

  // search term from metrics tab activity
  searchMetrcis(event) {
    this.metricsSearchTerm = event;
  }
  searchedMetricItems(result){
    this.searchedMetricResult = result;
  }
  // displying filter popup when user click on filter button
  filterMetricLogs() {
    if (this.metricAction) {
      this.metricFilter[0].options.filter((item) => {
        if (this.selectedMetricAction?.find(action => action === item.value)) {
          item.selected = true;
        }
      });
    } 
    // updating min, max date of table filter based on month filter
    const today = new Date();
    const dateCreated = new Date(this.data?.dateCreated);
    const minDate = dateCreated.getFullYear() === this.metricMonth.getFullYear() && dateCreated.getMonth() === this.metricMonth.getMonth() ? this.data?.dateCreated : this.metricMonth;
    const maxDate = this.metricMonth.getFullYear() === today.getFullYear() && this.metricMonth.getMonth() === today.getMonth() ? today : new Date(this.metricMonth.getFullYear(), this.metricMonth.getMonth()+1, 0);
    const data: any = {
      name: translate('TENANT_DETAILS.METRICS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      isMultiSelect: true,
      filteredColumns: this.metricFilter,
      metricAction: this.metricFilter[0].options,
      metricStartDate: this.metricStartDate ? moment(this.metricStartDate) : '',
      metricEndDate: this.metricEndDate ? moment(this.metricEndDate) : '',
      metricColumns: ['action', 'date'],
      metricMinDate: minDate ? moment(minDate) : '',
      metricMaxDate: maxDate ? moment(maxDate) : ''
    };
    this.sidenavService
      .openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filteredColumns) => {
        if (filteredColumns) {
          this.clearData = true;
          if (filteredColumns[0] !== '') {
            this.metricAction = filteredColumns[0];
          }
          if (filteredColumns[0]?.length === 0 && filteredColumns[1] && !filteredColumns[1].filteredStartDate && !filteredColumns[1].filteredEndDate) {
            this.resetMetricFilter();
          } else {
           this.filterMetricItems(filteredColumns);
          } 
        }
      });
  }
  /**
   * filtering metric table based on filteredColumns
   * @param filteredColumns 
   */
  filterMetricItems(filteredColumns): void {
    this.metricLogData = this.metricsLog;
    if(!filteredColumns){
      this.initialMetricItems()
    }
    if (filteredColumns) {
      this.selectedMetricAction = [];
      this.metricStartDate = undefined;
      this.metricEndDate = undefined;
      this.metricFilter[0].options.filter((item) => {item.selected = false;});
      if (filteredColumns[0]?.length > 0) {
        this.selectedMetricAction = filteredColumns[0];
        localStorage.setItem('filteredMetricAction',JSON.stringify(this.selectedMetricAction));
        this.metricLogData = this.metricLogData?.filter((item) =>this.selectedMetricAction?.includes(item?.action));
      } else {
        localStorage.removeItem('filteredMetricAction');
      }
      if (filteredColumns[1] && filteredColumns[1].filteredStartDate && filteredColumns[1].filteredEndDate) {
        this.metricStartDate = filteredColumns[1].filteredStartDate;
        this.metricEndDate = filteredColumns[1].filteredEndDate;
        localStorage.setItem('filteredMetricStartDate', this.metricStartDate);
        localStorage.setItem('filteredMetricEndDate', this.metricEndDate);
        this.metricLogData = this.metricLogData.filter(
          (item) =>
            this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >=
              this.datePipe.transform(this.metricStartDate, 'yyyy-MM-dd') &&
            this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <=
              this.datePipe.transform(this.metricEndDate, 'yyyy-MM-dd')
        );
      } else {
        localStorage.removeItem('filteredMetricStartDate');
        localStorage.removeItem('filteredMetricEndDate');
      }
    }
  }
  getAction(action) {
    return this.metricActionOptions.find((item) => item.value === action).label;
  }
  initialMetricItems() {
    this.metricLogData = this.metricsLog;
    if (this.selectedMetricAction?.length > 0) {
      this.metricLogData = this.metricLogData?.filter((item) => this.selectedMetricAction?.includes(item?.action))
    }
    if(this.metricStartDate && this.metricEndDate){
      this.metricLogData = this.metricLogData.filter((item) => this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.metricStartDate, 'yyyy-MM-dd') && this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.metricEndDate, 'yyyy-MM-dd'));
    }
  }
  /**
   * removed selected action filter
   * @param data 
   */
  cancelMetricAction(data) {
    let selectedItem = this.selectedMetricAction.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredMetricAction');
      this.selectedMetricAction.splice(selectedItem, 1);
      this.metricFilter[0].options.find((item) => item.value === data).selected = false;
      localStorage.setItem('filteredMetricAction',JSON.stringify(this.selectedMetricAction));
      this.filterMetricItems(this.filteredColumns);
    }
  }
  // remevod selected date filter
  cancelMetricDate() {
    localStorage.removeItem('filteredMetricStartDate');
    localStorage.removeItem('filteredMetricEndDate');
    this.metricEndDate = undefined;
    this.metricStartDate = undefined;
    this.filterMetricItems(this.filteredColumns);
  }
  // resetting metric dasboard filter
  resetMetricFilter() {
    this.selectedMetricAction = [];
    this.metricEndDate = undefined;
    this.metricStartDate = undefined;
    this.metricFilter[0].options.filter((item) => {item.selected = false;});
    this.metricLogData = this.metricsLog;
    localStorage.removeItem('filteredMetricAction');
    localStorage.removeItem('filteredMetricStartDate');
    localStorage.removeItem('filteredMetricEndDate');
  }

  //download data in csv format
  downloadCSV(downloadType) {
    let csvContent = '';
    let filename = '';
    if (downloadType === 'products') {
      csvContent = 'NAME, VERSION, IMAGE\n';
      filename = 'Products.csv'
      this.inventoryProductsData.forEach(row => {
        csvContent += `${this.capitalizeFirst.transform(row.name)},${row.version},${row.image}\n`;
      });
    } else if (downloadType === 'components') {
        csvContent = 'NAME, VERSION, STATUS\n';
        filename = 'Components.csv'
        this.inventoryComponentData.forEach(row => {
          csvContent += `${this.capitalizeFirst.transform(row.component)},${row.version},${this.capitalizeFirst.transform(row.status)}\n`;
        });
    } else if (downloadType === 'cloudResources') {
        csvContent = 'NAME, TYPE, KIND, SKU\n';
        filename = 'Cloud Resources.csv'
        this.cloudResourceData.forEach(row => {
          csvContent += `${this.capitalizeFirst.transform(row.name)},${this.capitalizeFirst.transform(row.type)},${this.capitalizeFirst.transform(row?.kind)},${this.capitalizeFirst.transform(row?.sku?.name)}\n`;
        });
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }

  /**
   * filtering metric table based on selected month
   * @param selectedMonth 
   */
  applyMonthFilter(selectedMonth){
    this.metricMonth = new Date(selectedMonth);
    this.metricLogData = this.metricResponse?.filter(item => {
      const itemDate = new Date(item.startTime);
      return itemDate.getFullYear() === this.metricMonth.getFullYear() && itemDate.getMonth() === this.metricMonth.getMonth();
    });
    this.metricsLog = this.metricLogData;
    this.modifyConfigState();
    const year = this.metricMonth.getFullYear();
    const month = (this.metricMonth.getMonth() + 1).toString().padStart(2, '0');
    const yyyyMm = `${year}-${month}`;
    this.metricTimePieMonth = yyyyMm;
    this.loadUsageSummary(this.selectedMetricInstance,this.metricTimePieMonth);
  }

  loadUsageSummary(instanceId, month) {
    this.timetakenChartLoaded = false;
    this.isErrorResponse = false;
    this.isResponseOk = false;
    this.instanceService
      .getInstanceUsageSummarybyId(instanceId,month)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        const usageSum = Array.isArray(data) && data.length > 0 ? data[0] : null;
        if (usageSum) {
          if (usageSum.runningHours)
            this.runHours = usageSum.runningHours;
          if (usageSum.shutdownHours)
           this.shutDownHours = usageSum.shutdownHours;
        }
      this.isResponseOk = true;
        },
        (error) => {
          this.isErrorResponse = true;
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : error?.error?.message ? error?.error?.message : error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR');
            this.toastrService.errMessage(message, title);
          }, 500);
        }
      );
  }

  /**
   * Applies sorting to the table data based on the selected column and sort direction.
   * @param event - sort event containing the column name and sort order.
   */
  applyColumnSort(event) : void {
    let currentTabledata = this.efTest ? this.efTestResults : this.sanityTestResults;
    let data = currentTabledata?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'testStartTime':
          comparatorResult = a?.testStartTime && b?.testStartTime ? a?.testStartTime?.localeCompare(b?.testStartTime) : !a?.testStartTime ? -1 : 1;
          break;
        case 'testFinishTime':
          comparatorResult = a?.testFinishTime && b?.testFinishTime ? a?.finishTime?.localeCompare(b?.testFinishTime) : !a?.testFinishTime ? -1 : 1;
          break;
        case 'duration':
         comparatorResult = a?.testStartTime && b?.testStartTime && a?.testFinishTime && b?.testFinishTime ? this.timeDuration.transform(a?.testStartTime, a?.testFinishTime, "")?.localeCompare(this.timeDuration.transform(b?.testStartTime, b?.testFinishTime, "")) : !this.timeDuration.transform(b?.testStartTime, b?.testFinishTime, "") ? -1 : 1;
         break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
    this.pageIndex = 0;
    if (this.efTest) {
      this.dataSourceEFTestResults = new MatTableDataSource(data?.slice(0, 0 + 10));
    } else {
      this.dataSourceSanityTestResults = new MatTableDataSource(data?.slice(0, 0 + 10));
    }  
  }

}
